"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3834,5772],{

/***/ 85733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ dynamicEntry; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);




var dynamicEntry = function(importFn) {
    var DynamicComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return importFn().then(function(mod) {
            // eslint-disable-next-line react/display-name
            var Component = function(props) {
                var inputProps = props.inputProps, loaderProps = props.loaderProps, context = props.context;
                return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, mod.default.render(inputProps, loaderProps, context));
            };
            return Component;
        });
    }, {
        ssr: false
    });
    // Loader wrapper that dynamically imports the module and calls its loader
    // This ensures server-side data fetching works even with dynamic components
    var loaderWrapper = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(inputProps, root, pageProps) {
            var mod;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            importFn()
                        ];
                    case 1:
                        mod = _state.sent();
                        if (mod.default.loader) {
                            return [
                                2,
                                mod.default.loader(inputProps, root, pageProps)
                            ];
                        }
                        return [
                            2,
                            null
                        ];
                }
            });
        });
        return function loaderWrapper(inputProps, root, pageProps) {
            return _ref.apply(this, arguments);
        };
    }();
    var Component = {
        render: function(inputProps, loaderProps, context) {
            return react__WEBPACK_IMPORTED_MODULE_0__.createElement(DynamicComponent, {
                inputProps: inputProps,
                loaderProps: loaderProps,
                context: context
            });
        },
        loader: loaderWrapper
    };
    return Component;
};


/***/ }),

/***/ 55961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var components_landing_pages_v2_HeroV2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46233);
/* harmony import */ var components_landing_pages_v2_HeroV2WithMarkers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50069);
/* harmony import */ var _dynamicEntry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85733);
// Static imports (critical LCP)



// Dynamic imports
var ExternalLinks = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 8381).then(__webpack_require__.bind(__webpack_require__, 98381));
});
var BasicPageHeader = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 8190).then(__webpack_require__.bind(__webpack_require__, 28190));
});
var Calculator = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8111), __webpack_require__.e(6881), __webpack_require__.e(5776)]).then(__webpack_require__.bind(__webpack_require__, 25776));
});
var CarouselCards = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 7779).then(__webpack_require__.bind(__webpack_require__, 97779));
});
var ComparisonTable = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 7128).then(__webpack_require__.bind(__webpack_require__, 67128));
});
var ContactSection = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 7712).then(__webpack_require__.bind(__webpack_require__, 7712));
});
// import CountdownTimer from 'components/landing-pages-v2/CountdownTimer';
var CTAStandalone = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6245), __webpack_require__.e(9734)]).then(__webpack_require__.bind(__webpack_require__, 99734));
});
var FAQsDisplay = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 1375).then(__webpack_require__.bind(__webpack_require__, 11375));
});
var Feature5050 = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 6536).then(__webpack_require__.bind(__webpack_require__, 46536));
});
var HeaderStandalone = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 747).then(__webpack_require__.bind(__webpack_require__, 50747));
});
var HeroCTA = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 8204).then(__webpack_require__.bind(__webpack_require__, 78204));
});
var ImageCard = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 9658).then(__webpack_require__.bind(__webpack_require__, 59658));
});
var LinkList = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 808).then(__webpack_require__.bind(__webpack_require__, 10808));
});
var List = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 687).then(__webpack_require__.bind(__webpack_require__, 60687));
});
var LWCHeroCard = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 9918).then(__webpack_require__.bind(__webpack_require__, 29918));
});
var LWCImageCard = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 536).then(__webpack_require__.bind(__webpack_require__, 10536));
});
var LWCTextSection = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 1344).then(__webpack_require__.bind(__webpack_require__, 11344));
});
var MapBackgroundHero = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 5715).then(__webpack_require__.bind(__webpack_require__, 55715));
});
var MarketStats = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 7072).then(__webpack_require__.bind(__webpack_require__, 27072));
});
var Multicard = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 6766).then(__webpack_require__.bind(__webpack_require__, 26766));
});
var OpenPositions = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6930), __webpack_require__.e(7380)]).then(__webpack_require__.bind(__webpack_require__, 37380));
});
var OptionsComparison = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 9555).then(__webpack_require__.bind(__webpack_require__, 79555));
});
var Quotation = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 3504).then(__webpack_require__.bind(__webpack_require__, 43504));
});
var Reviews = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 5079).then(__webpack_require__.bind(__webpack_require__, 75079));
});
var Spacer = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 5739).then(__webpack_require__.bind(__webpack_require__, 95739));
});
var StandaloneText = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 51831));
});
var TimeSavingsCalculator = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7058), __webpack_require__.e(1892)]).then(__webpack_require__.bind(__webpack_require__, 71892));
});
var VideoPlayer = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return __webpack_require__.e(/* import() */ 7881).then(__webpack_require__.bind(__webpack_require__, 47881));
});
var TrustpilotWidget = (0,_dynamicEntry__WEBPACK_IMPORTED_MODULE_2__/* .dynamicEntry */ .f)(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 14314));
});
var landingPageV2EntryLookup = {
    block: {
        lpComponentMapBackgroundHero: MapBackgroundHero,
        lpComponentCarouselCards: CarouselCards,
        lpComponentImageCard: ImageCard,
        lpComponentFaqDisplay: FAQsDisplay,
        lpComponentHeroV2: components_landing_pages_v2_HeroV2__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
        lpComponentContactSection: ContactSection,
        lpComponentLwcTextSection: LWCTextSection,
        lpComponentLwcHeroCard: LWCHeroCard,
        lpComponentLwcImageCard: LWCImageCard,
        lpComponentHeroV2WithMarkers: components_landing_pages_v2_HeroV2WithMarkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
        lpComponentCTAStandalone: CTAStandalone,
        lpComponentComparisonTable: ComparisonTable,
        lpComponentFeature5050: Feature5050,
        lpComponentHeaderStandalone: HeaderStandalone,
        lpComponentHeroCta: HeroCTA,
        lpComponentList: List,
        lpComponentStandaloneText: StandaloneText,
        lpComponentMulticard: Multicard,
        lpComponentBasicPageHeader: BasicPageHeader,
        lpComponentLinkList: LinkList,
        lpComponentQuotation: Quotation,
        lpComponentSpacer: Spacer,
        lpComponentOpenPositions: OpenPositions,
        lpComponentOptionsComparison: OptionsComparison,
        lpComponentOpendoorReviews: Reviews,
        lpComponentCalculator: Calculator,
        lpComponentTimeSavingsCalculator: TimeSavingsCalculator,
        // lpComponentCountdownTimer: CountdownTimer,
        lpComponentVideoPlayer: VideoPlayer,
        lpComponentMarketStats: MarketStats,
        trustpilotWidget: TrustpilotWidget,
        componentRelatedExternalLinks: ExternalLinks
    },
    inline: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (landingPageV2EntryLookup);


/***/ }),

/***/ 96887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AL": function() { return /* binding */ fetchLandingPageV2BySlug; },
  "Mq": function() { return /* binding */ getCashOfferModal; },
  "$C": function() { return /* binding */ transformHeaderNavToMegaNav; }
});

// UNUSED EXPORTS: fetchArticleBySlug, fetchMainSiteFooter, fetchMainSiteHeader, fetchMainSiteHeaderAndFooter, fetchTopicPageBySlug

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-plain-text-renderer/dist/rich-text-plain-text-renderer.es5.js
var rich_text_plain_text_renderer_es5 = __webpack_require__(32924);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./src/cms/api.ts
var api = __webpack_require__(96141);
// EXTERNAL MODULE: ./src/cms/entries/articleV2.ts + 15 modules
var articleV2 = __webpack_require__(18834);
// EXTERNAL MODULE: ./src/cms/entries/landingPageV2.ts
var landingPageV2 = __webpack_require__(55961);
// EXTERNAL MODULE: ./src/cms/entries/topicPageV2.ts + 9 modules
var topicPageV2 = __webpack_require__(20940);
;// CONCATENATED MODULE: ./src/cms/loaders.ts



function loaders_hydrateEntries(options) {
    var includes = options.includes, entryLookup = options.entryLookup, root = options.root, pageContext = options.pageContext;
    // The rest of the function implementation remains the same
    var loaderPromises = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var x = _step.value;
            var contentType = x.sys.contentType.sys.id;
            var entryId = x.sys.id;
            if (!contentType) {
                return "continue";
            }
            var entryComponent = entryLookup.block[contentType];
            if (!(entryComponent === null || entryComponent === void 0 ? void 0 : entryComponent.loader)) {
                return "continue";
            }
            var loader = entryComponent === null || entryComponent === void 0 ? void 0 : entryComponent.loader;
            var safeLoader = function() {
                var _ref = (0,src_async_to_generator/* default */.Z)(function() {
                    var results, e, _obj, ref;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    loader(x, root, {
                                        paginationIndex: (pageContext === null || pageContext === void 0 ? void 0 : pageContext.pageNum) || 1,
                                        url: pageContext.url
                                    })
                                ];
                            case 1:
                                results = _state.sent();
                                return [
                                    2,
                                    [
                                        entryId,
                                        results
                                    ]
                                ];
                            case 2:
                                e = _state.sent();
                                (ref = (_obj = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, e, {
                                    data: {
                                        entryId: entryId
                                    }
                                });
                                return [
                                    2,
                                    [
                                        entryId,
                                        null
                                    ]
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function safeLoader() {
                    return _ref.apply(this, arguments);
                };
            }();
            loaderPromises.push(safeLoader());
        };
        for(var _iterator = includes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return loaderPromises;
}

;// CONCATENATED MODULE: ./src/cms/index.ts













/**
 * Fetch depth required to support MegaNav structure:
 * Page → header → mainNav → sections → links
 */ var FETCH_DEEP = 4;
var FETCH_SHALLOW = 2;
var sysFields = (/* unused pure expression or super */ null && ([
    "createdAt",
    "updatedAt"
]));
var metaFields = (/* unused pure expression or super */ null && ([
    "tags"
]));
var selectedFields = (/* unused pure expression or super */ null && ([
    "slug",
    "seoBase",
    "authors",
    "showAuthorFooter",
    "articleName",
    "articleSubtitle",
    "header",
    "footer",
    // no relatedArticles
    "headerSummary",
    "headerImage",
    "keyTakeaways",
    "body",
    "editors",
    "reviewers",
    "openGraph",
    "openGraphArticle",
    "twitterCard",
    "publisher",
    "publishDate",
    "actualizationDate",
    "hideReadingTime", 
]));
function fetchArticleMetadata(client, slug) {
    return _fetchArticleMetadata.apply(this, arguments);
}
function _fetchArticleMetadata() {
    _fetchArticleMetadata = _async_to_generator(function(client, slug) {
        var fieldsWithoutBody, entry;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    fieldsWithoutBody = selectedFields.filter(function(f) {
                        return f !== "body" && f !== "keyTakeaways";
                    });
                    return [
                        4,
                        client.getEntries({
                            content_type: "article",
                            include: FETCH_DEEP,
                            "fields.slug": slug,
                            select: sysFields.map(function(x) {
                                return "sys.".concat(x);
                            }).concat(fieldsWithoutBody.map(function(x) {
                                return "fields.".concat(x);
                            })).concat(metaFields.map(function(x) {
                                return "metadata.".concat(x);
                            })).join(","),
                            limit: 1
                        })
                    ];
                case 1:
                    entry = _state.sent();
                    return [
                        2,
                        entry.items.length > 0 ? entry : null
                    ];
            }
        });
    });
    return _fetchArticleMetadata.apply(this, arguments);
}
function fetchArticleBody(client, slug) {
    return _fetchArticleBody.apply(this, arguments);
}
function _fetchArticleBody() {
    _fetchArticleBody = _async_to_generator(function(client, slug) {
        var bodyEntry;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.getEntries({
                            content_type: "article",
                            include: FETCH_SHALLOW,
                            "fields.slug": slug,
                            select: "fields.body,fields.keyTakeaways",
                            limit: 1
                        })
                    ];
                case 1:
                    bodyEntry = _state.sent();
                    return [
                        2,
                        bodyEntry.items.length > 0 ? bodyEntry : null
                    ];
            }
        });
    });
    return _fetchArticleBody.apply(this, arguments);
}
function mergeArticleData(metadataEntry, bodyEntry) {
    var ref, ref1;
    if (!metadataEntry || !bodyEntry) {
        throw new Error("Cannot merge article data: missing metadata or body");
    }
    var safeMetadata = JSON.parse(metadataEntry.stringifySafe());
    var safeBody = JSON.parse(bodyEntry.stringifySafe());
    var article = safeMetadata.items[0];
    article.fields.body = safeBody.items[0].fields.body;
    article.fields.keyTakeaways = safeBody.items[0].fields.keyTakeaways;
    var ref2, ref3;
    var mergedIncludes = _to_consumable_array((ref2 = (ref = safeMetadata.includes) === null || ref === void 0 ? void 0 : ref.Entry) !== null && ref2 !== void 0 ? ref2 : []).concat(_to_consumable_array((ref3 = (ref1 = safeBody.includes) === null || ref1 === void 0 ? void 0 : ref1.Entry) !== null && ref3 !== void 0 ? ref3 : []));
    return {
        article: article,
        mergedIncludes: mergedIncludes
    };
}
function hydrateArticleEntries(article, mergedIncludes, requestUrl, slug) {
    return _hydrateArticleEntries.apply(this, arguments);
}
function _hydrateArticleEntries() {
    _hydrateArticleEntries = _async_to_generator(function(article, mergedIncludes, requestUrl, slug) {
        var hydratedEntries, e, _obj, ref;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        Promise.all(hydrateEntries({
                            includes: mergedIncludes,
                            entryLookup: articleEntryLookup,
                            root: article,
                            pageContext: {
                                url: requestUrl
                            }
                        }))
                    ];
                case 1:
                    hydratedEntries = _state.sent();
                    return [
                        2,
                        Object.fromEntries(hydratedEntries)
                    ];
                case 2:
                    e = _state.sent();
                    (ref = (_obj = globalObservability.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, e, {
                        data: {
                            slug: slug
                        }
                    });
                    return [
                        2,
                        {}
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _hydrateArticleEntries.apply(this, arguments);
}
/*
  Mixed-depth fetch strategy for articles:

  To support deep navigation (4 levels) while avoiding oversized responses,
  we fetch metadata and body content separately:
  1. Metadata + navigation (include=4) for full MegaNav structure
  2. Body content (include=1) to keep response size manageable

  This prevents "Invalid string length" errors on articles with many embedded assets
  while maintaining full navigation functionality.
*/ function fetchArticleBySlug(_) {
    return _fetchArticleBySlug.apply(this, arguments);
}
function _fetchArticleBySlug() {
    _fetchArticleBySlug = _async_to_generator(function(param) {
        var slug, requestUrl, ref, client, calculateReadingTime, roundReadingTime, ref1, metadataEntry, bodyEntry, ref2, article, mergedIncludes, _, readingTimeMinutes, idToLoaderData, _keyTakeaways, fields;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    slug = param.slug, requestUrl = param.requestUrl;
                    client = createContentfulClient();
                    calculateReadingTime = function(input) {
                        var WORDS_PER_MINUTE = 200;
                        var matches = input.match(/(\w+)/g);
                        if (!matches) {
                            return null;
                        }
                        return matches.length / WORDS_PER_MINUTE;
                    };
                    roundReadingTime = function(time) {
                        return time !== null ? Math.round(time) : null;
                    };
                    return [
                        4,
                        Promise.all([
                            fetchArticleMetadata(client, slug),
                            fetchArticleBody(client, slug)
                        ])
                    ];
                case 1:
                    ref1 = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        2
                    ]), metadataEntry = ref1[0], bodyEntry = ref1[1];
                    if (!metadataEntry || !bodyEntry) {
                        return [
                            2,
                            null
                        ];
                    }
                    ref2 = mergeArticleData(metadataEntry, bodyEntry), article = ref2.article, mergedIncludes = ref2.mergedIncludes;
                    _ = article.fields;
                    return [
                        4,
                        getRelatedArticles(article).catch(function() {
                            return [];
                        })
                    ];
                case 2:
                    _.relatedArticles = _state.sent();
                    readingTimeMinutes = roundReadingTime(calculateReadingTime([
                        article.fields.articleName,
                        article.fields.headerSummary,
                        article.fields.keyTakeaways && documentToPlainTextString(article.fields.keyTakeaways),
                        documentToPlainTextString(article.fields.body)
                    ].filter(Boolean).join("")));
                    return [
                        4,
                        hydrateArticleEntries(article, mergedIncludes, requestUrl, slug)
                    ];
                case 3:
                    idToLoaderData = _state.sent();
                    fields = _object_spread_props(_object_spread({}, article.fields), {
                        keyTakeaways: (_keyTakeaways = article.fields.keyTakeaways) !== null && _keyTakeaways !== void 0 ? _keyTakeaways : null
                    });
                    return [
                        2,
                        {
                            sys: {
                                createdAt: article.sys.createdAt,
                                updatedAt: article.sys.updatedAt,
                                tags: ((ref = article.metadata.tags) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                    var ref;
                                    return item === null || item === void 0 ? void 0 : (ref = item.sys) === null || ref === void 0 ? void 0 : ref.id;
                                }).filter(Boolean)) || []
                            },
                            fields: fields,
                            readingTimeMinutes: readingTimeMinutes,
                            idToLoaderData: idToLoaderData
                        }
                    ];
            }
        });
    });
    return _fetchArticleBySlug.apply(this, arguments);
}
function fetchTopicPageBySlug(_) {
    return _fetchTopicPageBySlug.apply(this, arguments);
}
function _fetchTopicPageBySlug() {
    _fetchTopicPageBySlug = _async_to_generator(function(param) {
        var slug, pageNum, requestUrl, client, entries, safeEntries, topicPage, hydratedEntries, ref, ref1, e, _obj, ref2, idToLoaderData;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    slug = param.slug, pageNum = param.pageNum, requestUrl = param.requestUrl;
                    client = createContentfulClient();
                    return [
                        4,
                        client.getEntries({
                            content_type: "topicPage",
                            /*
      The field "include" specifies how many levels down of nested
      data that this fetch call should return. Please be aware that any
      value greater than 2 has significant impact on page performance.

      Setting to FETCH_DEEP to support MegaNav structure:
      TopicPage → header → mainNav → sections → links
    */ include: FETCH_DEEP,
                            "fields.slug": slug,
                            limit: 1
                        })
                    ];
                case 1:
                    entries = _state.sent();
                    if (entries.items.length === 0) {
                        return [
                            2,
                            null
                        ];
                    }
                    safeEntries = JSON.parse(entries.stringifySafe());
                    topicPage = safeEntries.items[0];
                    hydratedEntries = [];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        Promise.all(hydrateEntries({
                            includes: (ref1 = (ref = safeEntries.includes) === null || ref === void 0 ? void 0 : ref.Entry) !== null && ref1 !== void 0 ? ref1 : [],
                            entryLookup: topicPageEntryLookup,
                            root: topicPage,
                            pageContext: {
                                pageNum: pageNum,
                                url: requestUrl
                            }
                        }))
                    ];
                case 3:
                    hydratedEntries = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    (ref2 = (_obj = globalObservability.getSentryClient()).captureException) === null || ref2 === void 0 ? void 0 : ref2.call(_obj, e, {
                        data: {
                            slug: slug
                        }
                    });
                    return [
                        3,
                        5
                    ];
                case 5:
                    idToLoaderData = Object.fromEntries(hydratedEntries);
                    return [
                        2,
                        {
                            sys: {
                                createdAt: topicPage.sys.createdAt,
                                updatedAt: topicPage.sys.updatedAt,
                                locale: topicPage.sys.locale
                            },
                            fields: topicPage.fields,
                            idToLoaderData: idToLoaderData
                        }
                    ];
            }
        });
    });
    return _fetchTopicPageBySlug.apply(this, arguments);
}
function getRelatedArticles(article) {
    return _getRelatedArticles.apply(this, arguments);
}
function _getRelatedArticles() {
    _getRelatedArticles = _async_to_generator(function(article) {
        var ref, articleWithRelated;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchEntriesById("article", [
                            article.sys.id
                        ], {
                            select: "fields.relatedArticles",
                            include: 0
                        })
                    ];
                case 1:
                    articleWithRelated = _state.sent()[0];
                    return [
                        4,
                        fetchEntriesById("article", ((articleWithRelated === null || articleWithRelated === void 0 ? void 0 : (ref = articleWithRelated.fields) === null || ref === void 0 ? void 0 : ref.relatedArticles) || []).map(function(a) {
                            return a.sys.id;
                        }), {
                            select: "fields.slug,fields.authors,fields.articleName"
                        })
                    ];
                case 2:
                    return [
                        2,
                        _state.sent().filter(function(article) {
                            return !!article;
                        })
                    ];
            }
        });
    });
    return _getRelatedArticles.apply(this, arguments);
}
function getCashOfferModal() {
    return _getCashOfferModal.apply(this, arguments);
}
function _getCashOfferModal() {
    _getCashOfferModal = (0,src_async_to_generator/* default */.Z)(function() {
        var cashOfferModal, e, // Capture the exception using the Sentry client
        _obj, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,api/* fetchEntryById */.yR)("lpComponentGetCashOfferModal", "29FQNyPKP58Niqf5jcSM58", {
                            include: FETCH_DEEP
                        })
                    ];
                case 1:
                    cashOfferModal = _state.sent();
                    return [
                        2,
                        cashOfferModal
                    ];
                case 2:
                    e = _state.sent();
                    (ref = (_obj = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, e, {
                        data: {
                            entryId: "29FQNyPKP58Niqf5jcSM58"
                        }
                    });
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    });
    return _getCashOfferModal.apply(this, arguments);
}
function fetchLandingPageV2BySlug(_) {
    return _fetchLandingPageV2BySlug.apply(this, arguments);
}
function _fetchLandingPageV2BySlug() {
    _fetchLandingPageV2BySlug = (0,src_async_to_generator/* default */.Z)(function(param) {
        var slug, pageNum, requestUrl, locale, client, entry, safeEntry, page, hydratedEntries, ref, ref1, e, _obj, ref2, idToLoaderData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    slug = param.slug, pageNum = param.pageNum, requestUrl = param.requestUrl, locale = param.locale;
                    client = (0,api/* createContentfulClient */.u_)();
                    return [
                        4,
                        client.getEntries({
                            content_type: "landingPageV2",
                            /*
      The field "include" specifies how many levels down of nested
      data that this fetch call should return. Please be aware that any
      value greater than 2 may have a significant impact on page performance,
      so it should be used sparingly and content authors should understand the
      impact of overusing components with several levels of nested data.

      Setting to FETCH_DEEP to support MegaNav structure:
      LandingPage → header → mainNav → sections → links
    */ include: FETCH_DEEP,
                            "fields.slug": slug,
                            limit: 1,
                            locale: locale
                        })
                    ];
                case 1:
                    entry = _state.sent();
                    if (entry.items.length === 0) {
                        return [
                            2,
                            null
                        ];
                    }
                    safeEntry = JSON.parse(entry.stringifySafe());
                    page = safeEntry.items[0];
                    hydratedEntries = [];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        Promise.all(loaders_hydrateEntries({
                            includes: (ref1 = (ref = safeEntry.includes) === null || ref === void 0 ? void 0 : ref.Entry) !== null && ref1 !== void 0 ? ref1 : [],
                            entryLookup: landingPageV2/* default */.Z,
                            root: page,
                            pageContext: {
                                url: requestUrl,
                                pageNum: pageNum
                            }
                        }))
                    ];
                case 3:
                    hydratedEntries = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    (ref2 = (_obj = observability_slim/* globalObservability.getSentryClient */.w.getSentryClient()).captureException) === null || ref2 === void 0 ? void 0 : ref2.call(_obj, e, {
                        data: {
                            slug: slug
                        }
                    });
                    return [
                        3,
                        5
                    ];
                case 5:
                    idToLoaderData = Object.fromEntries(hydratedEntries);
                    return [
                        2,
                        {
                            fields: page.fields,
                            idToLoaderData: idToLoaderData,
                            markets: [],
                            public: page.fields.public
                        }
                    ];
            }
        });
    });
    return _fetchLandingPageV2BySlug.apply(this, arguments);
}
/**
 * Type guard: Check if item is a SimpleList (has sections) or just a Link
 */ function isSimpleList(item) {
    return (item === null || item === void 0 ? void 0 : item.fields) != null && "title" in item.fields && "links" in item.fields;
}
/**
 * Transforms a simple link (ILpElementLink) to { name, href }
 */ function transformSimpleLink(link) {
    var ref, ref1;
    return {
        name: ((ref = link.fields) === null || ref === void 0 ? void 0 : ref.text) || "",
        href: ((ref1 = link.fields) === null || ref1 === void 0 ? void 0 : ref1.url) || ""
    };
}
/**
 * Transforms a section (ILpElementSimpleList with nested ILpElementLink items)
 */ function transformSection(section) {
    var ref;
    var links = ((ref = section.fields.links) === null || ref === void 0 ? void 0 : ref.filter(function(link) {
        return link != null;
    }).map(function(link) {
        return transformSimpleLink(link);
    })) || [];
    return {
        title: section.fields.title || "",
        links: links
    };
}
/**
 * Transforms ISiteHeader mainNav into MegaNavItem[] format
 *
 * Two patterns:
 * 1. ILpElementLink → Simple nav item (e.g., "Agents")
 * 2. ILpElementSimpleList → Nav with dropdown containing sections (each section is also ILpElementSimpleList)
 */ function transformHeaderNavToMegaNav(mainNav) {
    if (!(mainNav === null || mainNav === void 0 ? void 0 : mainNav.length)) return [];
    return mainNav.filter(function(item) {
        return item === null || item === void 0 ? void 0 : item.fields;
    }).map(function(navItem) {
        var ref, ref1, ref2, ref3;
        // Pattern 1: Simple link without dropdown
        if (!isSimpleList(navItem)) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, transformSimpleLink(navItem)), {
                sections: undefined
            });
        }
        // Pattern 2: Nav item with dropdown sections
        var sections = (((ref = navItem.fields) === null || ref === void 0 ? void 0 : ref.links) || []).filter(function(link) {
            return link && isSimpleList(link);
        }).map(function(section) {
            return transformSection(section);
        });
        if (sections.length === 0) return null;
        return {
            name: ((ref1 = navItem.fields) === null || ref1 === void 0 ? void 0 : ref1.title) || "",
            href: ((ref3 = (ref2 = sections[0]) === null || ref2 === void 0 ? void 0 : ref2.links[0]) === null || ref3 === void 0 ? void 0 : ref3.href) || "#",
            sections: sections
        };
    }).filter(function(item) {
        return item !== null;
    });
}
// Default Contentful entry IDs for global header/footer
var DEFAULT_HEADER_ENTRY_ID = "17QZKVW8LvgeQ2PY4kMoxC"; // "Default - Global Nav"
var DEFAULT_FOOTER_ENTRY_ID = "7xQR3lEo4pIkwZx2RdRqFC"; // "Default SiteFooter"
/**
 * Fetches the main site header by its Contentful entry ID.
 * This allows non-CMS pages (like marketplace) to use the same header/meganav.
 *
 * Uses FETCH_DEEP (4) to get nested nav structure:
 * header → mainNav → sections → links
 */ function fetchMainSiteHeader() {
    return _fetchMainSiteHeader.apply(this, arguments);
}
function _fetchMainSiteHeader() {
    _fetchMainSiteHeader = _async_to_generator(function() {
        var header, error, _obj, ref;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetchEntryById("siteHeader", DEFAULT_HEADER_ENTRY_ID, {
                            include: FETCH_DEEP
                        })
                    ];
                case 1:
                    header = _state.sent();
                    return [
                        2,
                        header
                    ];
                case 2:
                    error = _state.sent();
                    (ref = (_obj = globalObservability.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, error, {
                        data: {
                            entryId: DEFAULT_HEADER_ENTRY_ID
                        }
                    });
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchMainSiteHeader.apply(this, arguments);
}
/**
 * Fetches the main site footer by its Contentful entry ID.
 * This allows non-CMS pages (like marketplace) to use the same footer.
 *
 * Uses FETCH_DEEP (4) to get nested nav structure:
 * footer → footerNav → links
 */ function fetchMainSiteFooter() {
    return _fetchMainSiteFooter.apply(this, arguments);
}
function _fetchMainSiteFooter() {
    _fetchMainSiteFooter = _async_to_generator(function() {
        var footer, error, _obj, ref;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetchEntryById("siteFooter", DEFAULT_FOOTER_ENTRY_ID, {
                            include: FETCH_DEEP
                        })
                    ];
                case 1:
                    footer = _state.sent();
                    return [
                        2,
                        footer
                    ];
                case 2:
                    error = _state.sent();
                    (ref = (_obj = globalObservability.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, error, {
                        data: {
                            entryId: DEFAULT_FOOTER_ENTRY_ID
                        }
                    });
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchMainSiteFooter.apply(this, arguments);
}
/**
 * Fetches both the main site header and footer by their Contentful entry IDs.
 * More efficient than calling fetchMainSiteHeader and fetchMainSiteFooter separately.
 */ function fetchMainSiteHeaderAndFooter() {
    return _fetchMainSiteHeaderAndFooter.apply(this, arguments);
}
function _fetchMainSiteHeaderAndFooter() {
    _fetchMainSiteHeaderAndFooter = _async_to_generator(function() {
        var ref, header, footer, error, _obj, ref1;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        Promise.all([
                            fetchEntryById("siteHeader", DEFAULT_HEADER_ENTRY_ID, {
                                include: FETCH_DEEP
                            }),
                            fetchEntryById("siteFooter", DEFAULT_FOOTER_ENTRY_ID, {
                                include: FETCH_DEEP
                            })
                        ])
                    ];
                case 1:
                    ref = _sliced_to_array.apply(void 0, [
                        _state.sent(),
                        2
                    ]), header = ref[0], footer = ref[1];
                    return [
                        2,
                        {
                            header: header !== null && header !== void 0 ? header : null,
                            footer: footer !== null && footer !== void 0 ? footer : null
                        }
                    ];
                case 2:
                    error = _state.sent();
                    (ref1 = (_obj = globalObservability.getSentryClient()).captureException) === null || ref1 === void 0 ? void 0 : ref1.call(_obj, error, {
                        data: {
                            headerEntryId: DEFAULT_HEADER_ENTRY_ID,
                            footerEntryId: DEFAULT_FOOTER_ENTRY_ID
                        }
                    });
                    return [
                        2,
                        {
                            header: null,
                            footer: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchMainSiteHeaderAndFooter.apply(this, arguments);
}


/***/ }),

/***/ 46000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ isSimpleLink; }
/* harmony export */ });
/**
 * Type guard to check if an item is a simple link (ILpElementLink) or a list (ILpElementSimpleList)
 */ function isSimpleLink(item) {
    return (item === null || item === void 0 ? void 0 : item.fields) != null && "text" in item.fields && "url" in item.fields;
}


/***/ }),

/***/ 75569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eu": function() { return /* binding */ addressNotFound; },
/* harmony export */   "Kl": function() { return /* binding */ extractStreetNumber; },
/* harmony export */   "Xo": function() { return /* binding */ AddressConfirmationModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(60179);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(52007);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(94746);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(25923);
/* harmony import */ var _opendoor_cinderblocks_helpers_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82293);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74593);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var helpers_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71899);
/* harmony import */ var _helpers_AddressValidationContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47211);
/* harmony import */ var _helpers_observability__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77997);













var Sentry = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__/* .globalObservability.getSentryClient */ .w.getSentryClient();
var extractStreetNumber = function(address) {
    var ref;
    var regex = /\b\d+[A-Za-z]*(?:-\d+[A-Za-z]*)?\b/;
    var matches = address === null || address === void 0 ? void 0 : (ref = address.street1) === null || ref === void 0 ? void 0 : ref.match(regex);
    return matches ? matches[0] : null;
};
var addressNotFound = function(errorData) {
    var msg = typeof errorData == "string" ? errorData : errorData.message;
    return msg.indexOf("NOT_FOUND") === 2;
};
var AddressConfirmationModal = function(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen, partnerReferralId = param.partnerReferralId, initialAddress = param.initialAddress, pageSetPath = param.pageSetPath, trackingKeywords = param.trackingKeywords, channel = param.channel, inputLocation = param.inputLocation, trackingTaxonomy = param.trackingTaxonomy;
    var t = (0,helpers_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useT */ .NT)().t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var trackEvent = (0,_helpers_observability__WEBPACK_IMPORTED_MODULE_6__/* .useObservability */ .C3)().trackEvent;
    var ref = (0,_helpers_AddressValidationContext__WEBPACK_IMPORTED_MODULE_5__/* .useAddressValidationContext */ .oK)(), addressResults = ref.addressResults, setValidatedAddress = ref.setValidatedAddress, validatedAddress = ref.validatedAddress;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, initialAddress)), address = ref1[0], setAddress = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), unitNumberErrorText = ref2[0], setUnitNumberErrorText = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isCreateSellerInputLoading = ref3[0], setIsCreateSellerInputLoading = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isNoUnitLoading = ref4[0], setIsNoUnitLoading = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), confirmSameUnitStreet = ref5[0], setConfirmSameUnitStreet = ref5[1];
    var isAddressUnitNumberMissing = addressResults === null || addressResults === void 0 ? void 0 : addressResults.includes("ADDRESS_MISSING_SUB_PREMISE");
    var streetNumber = extractStreetNumber(initialAddress);
    var validateUnitInput = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var ref, ref1, response, casaAddress, error, ref2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,_opendoor_cinderblocks_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* .standardizeAddress */ .ce)(address)
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response || !response.data || response.errors && !addressNotFound(response.errors[0])) {
                            setUnitNumberErrorText(t("addressConfirmationModal.errors.unexpected", "An unexpected error occurred. Please try again."));
                            return [
                                2
                            ];
                        }
                        casaAddress = (ref1 = (ref = response.data) === null || ref === void 0 ? void 0 : ref.casa.findByFields) === null || ref1 === void 0 ? void 0 : ref1.address;
                        if ((casaAddress === null || casaAddress === void 0 ? void 0 : casaAddress.result.includes(_helpers_AddressValidationContext__WEBPACK_IMPORTED_MODULE_5__/* .ADDRESS_INVALID_RESULT */ .le)) || response.errors && addressNotFound(response.errors[0])) {
                            setUnitNumberErrorText(t("addressConfirmationModal.errors.unitInvalid", "Unit number not found or entered incorrectly"));
                            return [
                                2
                            ];
                        }
                        return [
                            2,
                            {
                                street1: casaAddress.street,
                                city: casaAddress.city,
                                state: casaAddress.state,
                                postal_code: casaAddress.postalCode,
                                unit: casaAddress.unitNumber,
                                id: casaAddress.uuid
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        (ref2 = Sentry.captureException) === null || ref2 === void 0 ? void 0 : ref2.call(Sentry, error);
                        setUnitNumberErrorText(t("addressConfirmationModal.errors.unexpected", "An unexpected error occurred. Please try again."));
                        return [
                            2
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function validateUnitInput() {
            return _ref.apply(this, arguments);
        };
    }();
    var routeToManualAddressPage = function() {
        router.push({
            pathname: "/manual-address-entry",
            query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                address: JSON.stringify(validatedAddress)
            }, trackingKeywords != null && {
                trackingKeywords: trackingKeywords
            }, pageSetPath != null && {
                pageSetPath: pageSetPath
            }, partnerReferralId != null && {
                partnerReferralId: partnerReferralId
            }, channel != null && {
                channel: channel
            })
        });
    };
    var proceedWithAddress = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(addressToUse) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setValidatedAddress(addressToUse);
                        return [
                            4,
                            (0,_helpers_AddressValidationContext__WEBPACK_IMPORTED_MODULE_5__/* .gateProceedToOnboardingFlow */ .Qk)({
                                address: addressToUse,
                                product: "SELL_DIRECT",
                                trackEvent: trackEvent,
                                partnerReferralId: partnerReferralId,
                                addressUUID: addressToUse.id,
                                pageSetPath: pageSetPath,
                                trackingKeywords: trackingKeywords,
                                channel: channel,
                                inputLocation: inputLocation,
                                trackingTaxonomy: trackingTaxonomy
                            }).catch(function(error) {
                                var ref;
                                (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, error);
                                setUnitNumberErrorText(t("addressConfirmationModal.errors.unexpected", "An unexpected error occurred. Please try again."));
                            }).finally(function() {
                                setIsCreateSellerInputLoading(false);
                                setIsNoUnitLoading(false);
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function proceedWithAddress(addressToUse) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleNoUnit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            proceedWithAddress(address)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleNoUnit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleConfirmAddress = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var validatedAddress;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isAddressUnitNumberMissing) return [
                            3,
                            5
                        ];
                        // Unit number is required but missing
                        if (!(address === null || address === void 0 ? void 0 : address.unit)) {
                            setUnitNumberErrorText(t("addressConfirmationModal.errors.unitMissing", 'Enter a unit number or tap "No unit" below'));
                            setIsCreateSellerInputLoading(false);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            validateUnitInput()
                        ];
                    case 1:
                        validatedAddress = _state.sent();
                        if (!validatedAddress) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            proceedWithAddress(validatedAddress)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsCreateSellerInputLoading(false);
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            7
                        ];
                    case 5:
                        // No unit number needed, proceed directly
                        return [
                            4,
                            proceedWithAddress(address)
                        ];
                    case 6:
                        _state.sent();
                        _state.label = 7;
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirmAddress() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUnitNumberChange = function(input) {
        setConfirmSameUnitStreet(false);
        if (address) {
            setAddress((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, address), {
                unit: input
            }));
        }
        var validUnitNumberRegex = /^[A-Za-z0-9\s-#]+$/;
        if (input && !validUnitNumberRegex.test(input)) {
            setUnitNumberErrorText(t("addressConfirmationModal.errors.invalidCharacters", "Unit numbers can’t include special characters."));
        } else if (input === streetNumber) {
            setUnitNumberErrorText(t("addressConfirmationModal.errors.unitEqualsStreet", 'If street and unit number are the same, tap "Same street and unit" below.'));
        } else {
            setUnitNumberErrorText("");
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* .Dialog */ .V, {
        isOpen: isOpen,
        dismissable: true,
        overlayColor: "dark",
        setIsOpen: setIsOpen,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
            width: 600,
            $smallerThanLG: {
                width: "100%"
            },
            id: "address-confirmation-modal",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* .Dialog.Content */ .V.Content, {
                title: isAddressUnitNumberMissing ? t("addressConfirmationModal.title.unitMissing", "Is there a unit?") : t("addressConfirmationModal.title.default", "Is this the correct home address?"),
                description: "",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                    flexDirection: "column",
                    gap: 24,
                    $smallerThanLG: {
                        width: "100%",
                        gap: 16
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                            flexDirection: "row",
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            p: 24,
                            backgroundColor: "$backgroundStateInactiveTertiary",
                            borderRadius: "$16x",
                            $smallerThanLG: {
                                padding: 16,
                                borderRadius: "$8x"
                            },
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                                    tag: "p",
                                    typography: "$bodyXlarge",
                                    width: "60%",
                                    $smallerThanLG: {
                                        typography: "$bodyLarge",
                                        width: "70%"
                                    },
                                    children: [
                                        address === null || address === void 0 ? void 0 : address.street1,
                                        (address === null || address === void 0 ? void 0 : address.unit) ? ", #".concat(address.unit) : "",
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("br", {}),
                                        address === null || address === void 0 ? void 0 : address.city,
                                        ", ",
                                        address === null || address === void 0 ? void 0 : address.state,
                                        " ",
                                        address === null || address === void 0 ? void 0 : address.postal_code
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .TextButton */ .A, {
                                    analyticsName: "cosmos-edit-address",
                                    label: t("addressConfirmationModal.buttons.edit", "Edit"),
                                    onPress: routeToManualAddressPage,
                                    size: "medium",
                                    variant: "primary"
                                })
                            ]
                        }),
                        isAddressUnitNumberMissing && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .Fragment */ .HY, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .TextInput */ .o, {
                                    id: "cosmos-address-confirmation-input",
                                    size: "medium",
                                    title: t("addressConfirmationModal.labels.unitNumber", "Add apt, suite, unit, etc."),
                                    required: true,
                                    placeholder: t("addressConfirmationModal.placeholders.unitNumber", "Unit #1234"),
                                    errorText: unitNumberErrorText,
                                    onChangeText: handleUnitNumberChange
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 20,
                                    children: (address === null || address === void 0 ? void 0 : address.unit) === streetNumber && !confirmSameUnitStreet && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .TextButton */ .A, {
                                        variant: "primary",
                                        id: "same-street-unit",
                                        label: t("addressConfirmationModal.buttons.sameStreetUnit", "Same street and unit"),
                                        size: "large",
                                        $smallerThanLG: {
                                            size: "medium",
                                            pt: 7
                                        },
                                        analyticsName: "cosmos-same-street-unit",
                                        trackImpression: true,
                                        onPress: function() {
                                            setUnitNumberErrorText("");
                                            setConfirmSameUnitStreet(true);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .x, {
                            flexDirection: "row",
                            justifyContent: "space-between",
                            gap: 6,
                            width: "100%",
                            $smallerThanLG: {
                                flexDirection: "column",
                                gap: 10
                            },
                            children: [
                                isAddressUnitNumberMissing && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_17__/* .Button */ .z, {
                                    width: "50%",
                                    analyticsName: "address-confirmation-modal-no-unit",
                                    label: t("addressConfirmationModal.buttons.noUnit", "No unit"),
                                    onPress: function() {
                                        setIsNoUnitLoading(true);
                                        handleNoUnit();
                                    },
                                    size: "medium",
                                    variant: "secondary",
                                    $smallerThanLG: {
                                        width: "100%"
                                    },
                                    loading: isNoUnitLoading
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_17__/* .Button */ .z, {
                                    width: isAddressUnitNumberMissing ? "50%" : "100%",
                                    analyticsName: "address-confirmation-modal-confirm-address",
                                    label: t("addressConfirmationModal.buttons.confirmAddress", "Confirm Address"),
                                    onPress: function() {
                                        setIsCreateSellerInputLoading(true);
                                        handleConfirmAddress();
                                    },
                                    size: "medium",
                                    variant: "primary",
                                    $smallerThanLG: {
                                        width: "100%"
                                    },
                                    loading: isCreateSellerInputLoading,
                                    disabled: !!unitNumberErrorText
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 46233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* binding */ RenderHeroV2; },
  "Z": function() { return /* binding */ landing_pages_v2_HeroV2; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(95674);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/helpers/markets.ts
var markets = __webpack_require__(65446);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(37337);
// EXTERNAL MODULE: ./src/components/shared/performance/pictures.tsx
var pictures = __webpack_require__(29212);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/heroConstants.ts
var heroConstants = __webpack_require__(78986);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/hero/HeroImages.tsx







var HeroImageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box/* Box */.x, {
    target: "e19icmec0"
})({
    position: "relative",
    width: "100%",
    objectFit: "cover",
    borderRadius: "540px 540px 0px 0px",
    aspectRatio: "4 / 5",
    overflow: "hidden",
    "@media screen and (min-width: 768px)": {
        borderRadius: "540px 540px 36px 36px"
    }
});
var HeroImages = function(param) {
    var imageDesktopUrl = param.imageDesktopUrl, imageMobileUrl = param.imageMobileUrl, lowBandwidth = param.lowBandwidth;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "none",
                $largerThanMD: {
                    display: "block"
                },
                children: imageDesktopUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImageContainer, {
                    children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heroConstants/* HERO_IMAGE_DESKTOP_PROPS */.t), {
                        photoUrl: imageDesktopUrl
                    }), lowBandwidth ? {
                        quality: 50
                    } : {}))
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "block",
                $largerThanMD: {
                    display: "none"
                },
                children: imageMobileUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImageContainer, {
                    children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heroConstants/* HERO_IMAGE_MOBILE_PROPS */.S), {
                        photoUrl: imageMobileUrl
                    }), lowBandwidth ? {
                        quality: 50
                    } : {}))
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/HeroShared.tsx
var HeroShared = __webpack_require__(21076);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Image/Image.js + 1 modules
var Image = __webpack_require__(97009);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/TextButton.js
var TextButton = __webpack_require__(52007);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/Checkmark.js
var Checkmark = __webpack_require__(74816);
// EXTERNAL MODULE: ./src/helpers/i18n.tsx + 21 modules
var i18n = __webpack_require__(71899);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/SocialProofBox.tsx





var STUBBED_REVIEWS = [
    {
        rating: 5,
        excerptKey: "socialProof.review.sanAntonio",
        reviewer: {
            city: "San Antonio",
            productType: "sell"
        }
    },
    {
        rating: 5,
        excerptKey: "socialProof.review.okc",
        reviewer: {
            city: "Oklahoma City",
            productType: "sell"
        }
    },
    {
        rating: 5,
        excerptKey: "socialProof.review.phoenix",
        reviewer: {
            city: "Phoenix",
            productType: "sell"
        }
    }, 
];
var usePrefersReducedMotion = function() {
    var ref = (0,react.useState)(false), prefersReducedMotion = ref[0], setPrefersReducedMotion = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        if (false) {}
        setPrefersReducedMotion((ref = window.matchMedia("(prefers-reduced-motion: reduce)")) === null || ref === void 0 ? void 0 : ref.matches);
    }, []);
    return prefersReducedMotion;
};
var SocialProofBox = function(param) {
    var _autoplayInterval = param.autoplayInterval, autoplayInterval = _autoplayInterval === void 0 ? 4000 : _autoplayInterval;
    var prefersReducedMotion = usePrefersReducedMotion();
    var intervalRef = (0,react.useRef)();
    var ref = (0,react.useState)(0), currentReviewIndex = ref[0], setCurrentReviewIndex = ref[1];
    (0,react.useEffect)(function() {
        if (prefersReducedMotion) {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            return;
        }
        intervalRef.current = setInterval(function() {
            setCurrentReviewIndex(function(prevIndex) {
                return prevIndex === STUBBED_REVIEWS.length - 1 ? 0 : prevIndex + 1;
            });
        }, autoplayInterval);
        return function() {
            return clearInterval(intervalRef.current);
        };
    }, [
        prefersReducedMotion,
        autoplayInterval
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselFormat, {
        reviews: STUBBED_REVIEWS,
        currentIndex: currentReviewIndex,
        interval: autoplayInterval
    });
};
var FiveStarBanner = function(param) {
    var rating = param.rating;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        flexDirection: "row",
        gap: "$1x",
        children: new Array(rating).fill("star").map(function(_, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                alt: "Rating star",
                source: {
                    height: 16,
                    uri: "https://imgdrop.imgix.net/2024-11-1732263853253-76957.svg",
                    width: 16
                }
            }, index);
        })
    });
};
// takes the interval with `infinite` instead of redrawing
// the content constantly to trigger animation, may diverge over time
var fadeInCss = function(interval, index) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("transition:all 1s ease-in-out;animation:fadeIn-", index, " ", interval, "ms infinite ease-in-out;@keyframes fadeIn-", index, "{0%{opacity:0;}25%{opacity:1;}100%{opacity:0;}}");
};
var ReviewNav = function() {
    var t = (0,i18n/* useT */.NT)().t;
    var goToReviews = (0,react.useCallback)(function() {
        return window.location.assign("https://opendoor.com/reviews");
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextButton/* TextButton */.A, {
        analyticsName: "social-proof-carousel-see-reviews",
        "aria-label": t("socialProof.review.seeReviews", "See reviews"),
        onPress: goToReviews,
        variant: "primary",
        label: t("socialProof.review.seeReviews", "See reviews"),
        fontWeight: "regular",
        size: "small",
        width: 88,
        alignItems: "flex-end",
        $smallerThanLG: {
            size: "xsmall",
            width: 76
        }
    });
};
var CarouselFormat = function(param) {
    var reviews = param.reviews, currentIndex = param.currentIndex, interval = param.interval;
    var ref;
    var prefersReducedMotion = usePrefersReducedMotion();
    var t = (0,i18n/* useT */.NT)().t;
    if (reviews.length === 0) return null;
    var currentReview = reviews[currentIndex];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "$5x",
        borderRadius: "$12x",
        width: 652,
        padding: "$12x",
        style: {
            background: "rgba(242, 241, 240, 0.64)",
            backdropFilter: "blur(20px)",
            flex: "auto"
        },
        $smallerThanLG: {
            width: "100%",
            padding: "$8x",
            flexDirection: "column",
            gap: "$2x"
        },
        $smallerThanMD: {
            minHeight: 128,
            borderRadius: "$borderAllowance"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "column",
                width: "100%",
                style: {
                    flex: "auto"
                },
                css: prefersReducedMotion ? null : fadeInCss(interval, currentIndex),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FiveStarBanner, {
                        rating: currentReview.rating
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "$2x",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentSecondary",
                                $smallerThanLG: {
                                    typography: "$bodyXsmall"
                                },
                                children: [
                                    t("socialProof.review.sellerIn", "Seller in"),
                                    "\xa0",
                                    currentReview.reviewer.city
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelSmall",
                                color: "$contentAccentBrand",
                                $smallerThanLG: {
                                    typography: "$labelXsmall"
                                },
                                children: ((ref = currentReview.reviewer) === null || ref === void 0 ? void 0 : ref.name) || t("socialProof.review.verifiedCustomer", "Verified Customer")
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkmark/* default */.Z, {
                                size: 20,
                                color: "$contentAccentBrand"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "row",
                        gap: "$4x",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "span",
                            typography: "$bodyMedium",
                            color: "$contentPrimary",
                            $smallerThanLG: {
                                typography: "$bodySmall"
                            },
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            children: (currentReview === null || currentReview === void 0 ? void 0 : currentReview.excerpt) || currentReview.excerptKey && t(currentReview.excerptKey, "A great experience from the beginning...")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "flex",
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewNav, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/shared/NewSellerFlowAddressInput.tsx
var NewSellerFlowAddressInput = __webpack_require__(4618);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
;// CONCATENATED MODULE: ./src/components/shared/FiveUserImageRow.tsx


var imgDropUrl = function(id) {
    return "https://images.opendoor.com/source/s3/imgdrop-production/".concat(id, "?preset=square-1024&service=cosmos&dpr=2");
};
var FiveUserImageRow = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                display: "inline",
                $largerThanSM: {
                    display: "none"
                },
                source: {
                    uri: imgDropUrl("2025-11-1763666953751-13372.png"),
                    width: 136,
                    height: 40
                },
                alt: "A series of 5 overlapping avatars of Opendoor users"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                display: "none",
                $largerThanSM: {
                    display: "inline"
                },
                source: {
                    uri: imgDropUrl("2025-11-1763666953751-13372.png"),
                    width: 176,
                    height: 52
                },
                alt: "A series of 5 overlapping avatars of Opendoor users"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/shared/TrustpilotWidget.tsx
var TrustpilotWidget = __webpack_require__(14314);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/hero/TrustPilotWithUserImages.tsx





var TrustPilotWithUserImages = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PressableBox/* PressableBox */.K, {
        analyticsName: "homepage-trust-pilot-widget",
        "aria-label": "trust pilot review overview and link to them",
        href: "https://www.trustpilot.com/review/opendoor.com",
        width: 190,
        marginHorizontal: "auto",
        overflow: "hidden",
        rel: "noopener",
        target: "_blank",
        flexDirection: "row",
        alignItems: "center",
        rowGap: "$2x",
        flexWrap: "nowrap",
        position: "relative",
        justifyContent: "flex-start",
        $largerThanXS: {
            width: 325
        },
        $largerThanSM: {
            width: 365
        },
        $largerThanMD: {
            marginLeft: 0
        },
        height: 62,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                $smallerThanSM: {
                    display: "none"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FiveUserImageRow, {})
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustpilotWidget.RenderTrustpilotWidget, (0,_object_spread/* default */.Z)({}, {
                    fields: {
                        title: ""
                    },
                    rawWidget: true,
                    // overrides for custom/flex widget
                    tpCommonDataOverride: {
                        "data-template-id": "54197383fd9dceac42a68694",
                        "data-token-desktop": "cba266c7-0ba0-47f5-83c8-c4478b13cd3b",
                        "data-token-mobile": "7c30b375-b0d9-493e-94cb-eac4ca18ad32",
                        "data-style-size": "XS",
                        "data-text-color": "dark",
                        "data-headline": "star",
                        "data-background": "none",
                        "data-external-elements-color": "dark",
                        "data-style-height": "62",
                        "data-style-width": "200"
                    },
                    hideFallback: true
                }))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/hero/HeroTitleAndAddress.tsx









var HeroHeadline = function(param) {
    var title = param.title, subtitle = param.subtitle;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        gap: "$16x",
        alignItems: "center",
        $largerThanMD: {
            alignItems: "flex-start"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "h1",
                typography: "$displayXsmall",
                textAlign: "center",
                $largerThanSM: {
                    typography: "$displaySmall"
                },
                $largerThanMD: {
                    typography: "$displayMedium",
                    textAlign: "left"
                },
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodyMedium",
                textAlign: "center",
                $largerThanSM: {
                    typography: "$bodyLarge"
                },
                $largerThanMD: {
                    textAlign: "left"
                },
                children: subtitle
            })
        ]
    });
};
var StyledBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box/* Box */.x, {
    target: "e14lmup10"
})("div > div{border-color:", (0,cjs.getToken)("$borderAccentBrand"), " !important;}");
var HeroAddressSection = function(param) {
    var showAddressInput = param.showAddressInput, renderDesktopInput = param.renderDesktopInput, renderMobileInput = param.renderMobileInput, isTreatment = param.isTreatment;
    if (!showAddressInput) return null;
    var UseBox = isTreatment ? StyledBox : Box/* Box */.x;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        width: "100%",
        zIndex: 10,
        className: "hp-reskin-v2-address-entry-wrapper",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseBox, {
                id: "desktop-address-search",
                display: "none",
                $largerThanLG: {
                    display: "block"
                },
                children: renderDesktopInput()
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseBox, {
                id: "mobile-address-search",
                display: "block",
                $largerThanLG: {
                    display: "none"
                },
                children: renderMobileInput()
            }),
            isTreatment && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                typography: "$bodyMedium",
                tag: "p",
                color: "$contentSecondary",
                textAlign: "center",
                marginTop: "$6x",
                $largerThanLG: {
                    textAlign: "left"
                },
                children: "No obligation. Takes 5 minutes. Your information stays private."
            })
        ]
    });
};
var HeroCtaButtonsSection = function(param) {
    var _ctaButton1Text = param.ctaButton1Text, ctaButton1Text = _ctaButton1Text === void 0 ? "Missing label" : _ctaButton1Text, ctaButton1Url = param.ctaButton1Url, showCtaButton2 = param.showCtaButton2, _ctaButton2Text = param.ctaButton2Text, ctaButton2Text = _ctaButton2Text === void 0 ? "Missing label" : _ctaButton2Text, ctaButton2Url = param.ctaButton2Url, analyticsPrefix = param.analyticsPrefix;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        gap: "$12x",
        alignItems: "center",
        $largerThanMD: {
            flexDirection: "row",
            alignItems: "flex-start"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: "".concat(analyticsPrefix, "-cta-button-1"),
                label: ctaButton1Text,
                size: "large",
                variant: "primary",
                href: ctaButton1Url
            }),
            showCtaButton2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: "".concat(analyticsPrefix, "-cta-button-2"),
                label: ctaButton2Text,
                size: "large",
                variant: "secondary",
                href: ctaButton2Url
            })
        ]
    });
};
var addressInputCommonProps = function(analyticsId) {
    return {
        hideLabel: true,
        inputLocation: "hero-cta",
        analyticsPrefix: "cosmos-landing-page-hero-v2".concat(analyticsId ? "-".concat(analyticsId) : ""),
        trackingTaxonomy: "new_homepage"
    };
};
var StyledTreatmentButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button/* Button */.z, {
    target: "e14lmup11"
})("height:60px !important;margin-top:-17.5px;margin-right:-15px;");
var TreatmentButton = function(param) {
    var label = param.label, analyticsPrefix = param.analyticsPrefix, onPress = param.onPress, isLoading = param.isLoading;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTreatmentButton, {
        disabled: isLoading,
        analyticsName: analyticsPrefix,
        label: isLoading ? "Loading" : label,
        size: "medium",
        variant: "primary",
        onPress: function(e) {
            var // TextInput uses an InputFrame, which has an onPress registered and re-focuses the input.
            // To prevent the input from getting re-focused after blur, we need to prevent the event
            // from bubbling to InputFrame's onPress handler.
            ref;
            e === null || e === void 0 ? void 0 : (ref = e.stopPropagation) === null || ref === void 0 ? void 0 : ref.call(e);
            onPress === null || onPress === void 0 ? void 0 : onPress();
        }
    });
};
var HeroTitleAndAddress = function(param) {
    var analyticsId = param.analyticsId, title = param.title, subtitle = param.subtitle, showAddressInput = param.showAddressInput, showSocialSection = param.showSocialSection, renderDesktopInput = param.renderDesktopInput, renderMobileInput = param.renderMobileInput, additionalAddressContent = param.additionalAddressContent, addressEntryRef = param.addressEntryRef, _addressCtaText = param.addressCtaText, addressCtaText = _addressCtaText === void 0 ? "Get cash offer" : _addressCtaText, _addressCtaTextSmall = param.addressCtaTextSmall, addressCtaTextSmall = _addressCtaTextSmall === void 0 ? "Get offer" : _addressCtaTextSmall, addressCtaPlaceholderText = param.addressCtaPlaceholderText, addressCtaPlaceholderTextSmall = param.addressCtaPlaceholderTextSmall, showCtaButtonsContainer = param.showCtaButtonsContainer, ctaButton1Text = param.ctaButton1Text, ctaButton1Url = param.ctaButton1Url, showCtaButton2 = param.showCtaButton2, ctaButton2Text = param.ctaButton2Text, ctaButton2Url = param.ctaButton2Url;
    var analyticsPrefix = (0,HeroShared/* useHeroContext */.bx)().analyticsPrefix;
    var isTreatment = analyticsId === "big-swing-hero-v2";
    var treatmentCommonProps = addressInputCommonProps(analyticsId);
    var defaultRenderDesktopInput = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, treatmentCommonProps), {
            placeholder: addressCtaPlaceholderText || "Enter your home address",
            actionButton: function(onPress, isLoading) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TreatmentButton, {
                    analyticsPrefix: analyticsPrefix,
                    label: addressCtaText,
                    onPress: onPress,
                    isLoading: isLoading
                });
            }
        }));
    };
    var defaultRenderMobileInput = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, treatmentCommonProps), {
            placeholder: addressCtaPlaceholderTextSmall || "Enter an address",
            actionButton: function(onPress, isLoading) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TreatmentButton, {
                    analyticsPrefix: analyticsPrefix,
                    label: addressCtaTextSmall,
                    onPress: onPress,
                    isLoading: isLoading
                });
            }
        }));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        id: "title-and-address-entry",
        flexDirection: "column",
        width: "100%",
        gap: isTreatment ? "$8x" : "$16x",
        $largerThanSM: {
            gap: isTreatment ? "$20x" : "$16x"
        },
        $largerThanLG: {
            gap: isTreatment ? "$24x" : "$16x"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroHeadline, {
                title: title,
                subtitle: subtitle
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "none",
                ref: function(el) {
                    return addressEntryRef(el);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "$8x",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroAddressSection, {
                        showAddressInput: showAddressInput,
                        renderDesktopInput: renderDesktopInput || defaultRenderDesktopInput,
                        renderMobileInput: renderMobileInput || defaultRenderMobileInput,
                        additionalContent: additionalAddressContent,
                        isTreatment: isTreatment
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $smallerThanMD: {
                            display: "none"
                        },
                        $smallerThanLG: {
                            display: "inherit"
                        },
                        $largerThanMD: {
                            display: "none"
                        },
                        width: "100%",
                        children: showSocialSection && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialProofBox, {
                            autoplayInterval: 3000
                        })
                    })
                ]
            }),
            showCtaButtonsContainer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroCtaButtonsSection, {
                ctaButton1Text: ctaButton1Text,
                ctaButton1Url: ctaButton1Url,
                showCtaButton2: showCtaButton2,
                ctaButton2Text: ctaButton2Text,
                ctaButton2Url: ctaButton2Url,
                analyticsPrefix: analyticsPrefix
            }),
            isTreatment && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustPilotWithUserImages, {})
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/PressBox.tsx
var PressBox = __webpack_require__(44636);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/StickyCTAUtility/StickyCTAUtility.tsx + 1 modules
var StickyCTAUtility = __webpack_require__(97661);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/HeroV2.tsx













var RenderHeroV2 = function(entry, resolvedData, customization) {
    var router = (0,next_router.useRouter)();
    var authentication = (0,auth_fe_esm/* useAuth */.aC)().authentication;
    var fields = entry.fields;
    var isTreatment = fields.analyticsId === "big-swing-hero-v2";
    var hideStickyCta = (customization === null || customization === void 0 ? void 0 : customization.hideStickyCtaOverride) !== undefined ? Boolean(customization.hideStickyCtaOverride) : (resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.stickyCTA) === "None" || authentication.state === "authenticated";
    var headlineMarketIdentifier = router.query.headline_market_name;
    var headlineMarketDisplayName = (0,markets/* getMarketDisplayNameForHeroV2 */.O_)(headlineMarketIdentifier);
    var displayMarketNameInHeadline = headlineMarketDisplayName && "showMarketNameInHeadline" in fields && fields.showMarketNameInHeadline && !(customization === null || customization === void 0 ? void 0 : customization.headline);
    var headline = (customization === null || customization === void 0 ? void 0 : customization.headline) !== undefined ? customization.headline : (fields === null || fields === void 0 ? void 0 : fields.title) + (displayMarketNameInHeadline ? " in ".concat(headlineMarketDisplayName) : "");
    var ref = (0,HeroShared/* useStickyCTA */.AJ)(), addressEntryRef = ref.addressEntryRef, showStickyCTAUtility = ref.showStickyCTAUtility;
    var hasBothSocialAndPress = (fields === null || fields === void 0 ? void 0 : fields.showSocialSection) && (fields === null || fields === void 0 ? void 0 : fields.showPressSection);
    var variant = (customization === null || customization === void 0 ? void 0 : customization.variant) || "default";
    var analyticsPrefix = "cosmos-landing-page-hero-v2".concat((fields === null || fields === void 0 ? void 0 : fields.analyticsId) ? "-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId) : "");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroShared/* HeroProvider */.yL, {
        variant: variant,
        analyticsPrefix: analyticsPrefix,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            analyticsName: (customization === null || customization === void 0 ? void 0 : customization.analyticsName) || "cosmos-landing-page-hero-v2-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
            trackImpression: true,
            inViewThreshold: 0.3,
            children: [
                !hideStickyCta && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StickyCTAUtility/* StickyCTAUtility */.V, {
                    analyticsId: fields === null || fields === void 0 ? void 0 : fields.analyticsId,
                    isVisible: showStickyCTAUtility
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    width: "90%",
                    marginHorizontal: "auto",
                    paddingHorizontal: isTreatment ? 0 : "$20x",
                    $largerThanSM: {
                        paddingBottom: hasBothSocialAndPress ? "$32x" : "$0x"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        flexDirection: "column",
                        justifyContent: isTreatment ? "space-around" : "space-between",
                        rowGap: "$20x",
                        position: "relative",
                        $smallerThanSM: {
                            paddingTop: "$20x"
                        },
                        $largerThanSM: {
                            flexDirection: "row",
                            columnGap: "$16x",
                            rowGap: "$8x"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                $largerThanSM: {
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    width: "40%",
                                    flexShrink: 0
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroTitleAndAddress, {
                                    analyticsId: fields === null || fields === void 0 ? void 0 : fields.analyticsId,
                                    title: headline,
                                    subtitle: fields === null || fields === void 0 ? void 0 : fields.subtitle,
                                    showAddressInput: fields === null || fields === void 0 ? void 0 : fields.showAddressInputCta,
                                    showSocialSection: fields === null || fields === void 0 ? void 0 : fields.showSocialSection,
                                    renderDesktopInput: customization === null || customization === void 0 ? void 0 : customization.renderDesktopInput,
                                    renderMobileInput: customization === null || customization === void 0 ? void 0 : customization.renderMobileInput,
                                    additionalAddressContent: customization === null || customization === void 0 ? void 0 : customization.additionalAddressContent,
                                    addressEntryRef: addressEntryRef,
                                    addressCtaText: fields === null || fields === void 0 ? void 0 : fields.addressCtaText,
                                    addressCtaTextSmall: fields === null || fields === void 0 ? void 0 : fields.addressCtaTextSmall,
                                    addressCtaPlaceholderText: fields === null || fields === void 0 ? void 0 : fields.addressCtaPlaceholderText,
                                    addressCtaPlaceholderTextSmall: fields === null || fields === void 0 ? void 0 : fields.addressCtaPlaceholderTextSmall,
                                    showCtaButtonsContainer: fields === null || fields === void 0 ? void 0 : fields.showCtaButtonsContainer,
                                    ctaButton1Text: fields === null || fields === void 0 ? void 0 : fields.ctaButton1Text,
                                    ctaButton1Url: fields === null || fields === void 0 ? void 0 : fields.ctaButton1Url,
                                    showCtaButton2: fields === null || fields === void 0 ? void 0 : fields.showCtaButton2,
                                    ctaButton2Text: fields === null || fields === void 0 ? void 0 : fields.ctaButton2Text,
                                    ctaButton2Url: fields === null || fields === void 0 ? void 0 : fields.ctaButton2Url
                                })
                            }),
                            isTreatment ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                position: "relative",
                                $smallerThanMD: {
                                    display: "none"
                                },
                                $largerThanSM: {
                                    display: "flex"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImages, {
                                        imageDesktopUrl: fields === null || fields === void 0 ? void 0 : fields.imageDesktopUrl,
                                        imageMobileUrl: fields === null || fields === void 0 ? void 0 : fields.imageMobileUrl,
                                        lowBandwidth: customization === null || customization === void 0 ? void 0 : customization.lowBandwidth
                                    }),
                                    customization === null || customization === void 0 ? void 0 : customization.children
                                ]
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                position: "relative",
                                $largerThanSM: {
                                    width: "50%",
                                    flexShrink: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImages, {
                                        imageDesktopUrl: fields === null || fields === void 0 ? void 0 : fields.imageDesktopUrl,
                                        imageMobileUrl: fields === null || fields === void 0 ? void 0 : fields.imageMobileUrl,
                                        lowBandwidth: customization === null || customization === void 0 ? void 0 : customization.lowBandwidth
                                    }),
                                    customization === null || customization === void 0 ? void 0 : customization.children
                                ]
                            }),
                            ((fields === null || fields === void 0 ? void 0 : fields.showSocialSection) || (fields === null || fields === void 0 ? void 0 : fields.showPressSection)) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                id: "desktop-press-box",
                                position: "absolute",
                                left: "50%",
                                transform: "translateX(-50%)",
                                $largerThanSM: {
                                    bottom: hasBothSocialAndPress ? -100 : -40
                                },
                                $smallerThanMD: {
                                    position: "relative"
                                },
                                children: [
                                    (fields === null || fields === void 0 ? void 0 : fields.showSocialSection) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                        $smallerThanMD: {
                                            display: "inherit"
                                        },
                                        $smallerThanLG: {
                                            display: "none"
                                        },
                                        $largerThanMD: {
                                            display: "inherit"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialProofBox, {
                                            autoplayInterval: 3000
                                        })
                                    }),
                                    (fields === null || fields === void 0 ? void 0 : fields.showPressSection) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                        marginTop: "$16x",
                                        $smallerThanMD: {
                                            marginTop: 0
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressBox/* PressBox */.j, {})
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var heroV2Loader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input, root) {
        var preloadImages, loaderReturn;
        return (0,tslib_es6.__generator)(this, function(_state) {
            preloadImages = (0,HeroShared/* preloadHeroImages */.DB)({
                imageDesktopUrl: input.fields.imageDesktopUrl,
                imageMobileUrl: input.fields.imageMobileUrl
            });
            loaderReturn = {
                preloadImages: preloadImages,
                stickyCTA: (0,HeroShared/* getStickyCTAFromRoot */.Ul)(root)
            };
            return [
                2,
                loaderReturn
            ];
        });
    });
    return function heroV2Loader(input, root) {
        return _ref.apply(this, arguments);
    };
}();
var HeroV2 = {
    render: function(entry, resolvedData) {
        return RenderHeroV2(entry, resolvedData);
    },
    loader: heroV2Loader
};

/* harmony default export */ var landing_pages_v2_HeroV2 = (HeroV2);


/***/ }),

/***/ 50069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ landing_pages_v2_HeroV2WithMarkers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(95674);
// EXTERNAL MODULE: ./src/helpers/ReturnExperienceContext.tsx
var ReturnExperienceContext = __webpack_require__(78223);
// EXTERNAL MODULE: ./src/components/shared/NewSellerFlowAddressInput.tsx
var NewSellerFlowAddressInput = __webpack_require__(4618);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2.tsx + 5 modules
var HeroV2 = __webpack_require__(46233);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 4 modules
var IconButton = __webpack_require__(41538);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/RightArrow.js
var RightArrow = __webpack_require__(82717);
// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./src/helpers/returnExperience.tsx
var returnExperience = __webpack_require__(82993);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/ReturnExperience.tsx





var AltCTAButton = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* IconButton */.hU, {
        analyticsName: "cosmos-return-experience-".concat(returnExperience/* ExperienceType */.g[props.experience], "-icon-button"),
        icon: {
            Component: RightArrow/* default */.Z,
            label: "".concat(props.actionText)
        },
        onPress: function() {
            return props.url && window.location.assign(props.url);
        },
        size: "small",
        variant: "default",
        trackImpression: true
    });
};
var getActiveOfferExpiryText = function() {
    var daysToExpire = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
    var expiryText = "expires in 2 days";
    if (daysToExpire < 1) {
        expiryText = "expires today";
    } else if (daysToExpire < 2) {
        expiryText = "expires in 1 day";
    } else if (daysToExpire < 3) {
        expiryText = "expires in 2 days";
    } else if (daysToExpire === 3) {
        expiryText = "expires in 3 days";
    }
    return expiryText;
};
var Headline = function(props) {
    switch(props.experience){
        case returnExperience/* ExperienceType.direct_mailer */.g.direct_mailer:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: "Get started on your offer"
            });
        case returnExperience/* ExperienceType.offer_expired */.g.offer_expired:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    "Get your updated offer",
                    props.smallerThanMD ? "" : " today"
                ]
            });
        case returnExperience/* ExperienceType.incomplete_flow */.g.incomplete_flow:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    "Finish your offer",
                    props.smallerThanMD ? "" : " today"
                ]
            });
        case returnExperience/* ExperienceType.offer_increased */.g.offer_increased:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: "Your offer increased"
            });
        case returnExperience/* ExperienceType.offer_expiring */.g.offer_expiring:
        case returnExperience/* ExperienceType.offer_decreased */.g.offer_decreased:
        case returnExperience/* ExperienceType.active_offer */.g.active_offer:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    "Your offer ",
                    getActiveOfferExpiryText(props.daysToExpire)
                ]
            });
        default:
            return null;
    }
};
var ExperienceCTAButton = function(props) {
    var offerDashUrl = globals/* COSMOS_URL */.EQ;
    if (props.addressToken) {
        // Return to sell tab in hub for returning customers
        offerDashUrl = "".concat(globals/* CONSUMER_FE_URL */.ed, "/dashboard/sell/").concat(props.addressToken);
    } else if (props.sellerInputUUID) {
        offerDashUrl = "".concat(globals/* CONSUMER_FE_URL */.ed, "/dashboard/").concat(props.sellerInputUUID, "/overview");
    }
    switch(props.experience){
        case returnExperience/* ExperienceType.offer_expired */.g.offer_expired:
            {
                var baseUrl = offerDashUrl;
                var params = new URLSearchParams({
                    refresh_offer: "true",
                    refresh_source: "homepage_experience"
                }).toString();
                var refreshUrl = "".concat(baseUrl, "?").concat(params);
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AltCTAButton, {
                    actionText: "Refresh".concat(props.smallerThanMD ? " " : " your ", "offer"),
                    url: refreshUrl,
                    experience: props.experience
                });
            }
        case returnExperience/* ExperienceType.incomplete_flow */.g.incomplete_flow:
            // eslint-disable-next-line no-case-declarations
            var sellerFlowUrl = "".concat(globals/* CONSUMER_FE_URL */.ed, "/seller-lead/").concat(props.sellerInputUUID, "/").concat(props.sellerFlowLastCompletedSlug);
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AltCTAButton, {
                actionText: "Resume".concat(props.smallerThanMD ? " " : " your ", "offer"),
                url: sellerFlowUrl,
                experience: props.experience
            });
        case returnExperience/* ExperienceType.offer_increased */.g.offer_increased:
        case returnExperience/* ExperienceType.offer_expiring */.g.offer_expiring:
        case returnExperience/* ExperienceType.offer_decreased */.g.offer_decreased:
        case returnExperience/* ExperienceType.active_offer */.g.active_offer:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AltCTAButton, {
                actionText: "View".concat(props.smallerThanMD ? " " : " your ", "offer"),
                url: offerDashUrl,
                experience: props.experience
            });
        default:
            return null;
    }
};
var ReturnExperienceHero = function() {
    var returnExperienceData = (0,ReturnExperienceContext/* useReturnExperienceContext */.$)().returnExperienceData;
    var smallerThanSM = (0,cjs.useMedia)().smallerThanSM;
    if (!returnExperienceData || (returnExperienceData === null || returnExperienceData === void 0 ? void 0 : returnExperienceData.experienceType) === null) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        animation: "contentfulArchAnimation",
        animateOnly: [
            "opacity",
            "transform"
        ],
        enterStyle: {
            y: -30,
            opacity: 0
        },
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        top: -27,
        p: 16,
        pt: 43,
        analyticsName: "cosmos-return-experience-address-entry-slide-in",
        backgroundColor: "$backgroundSecondary",
        borderBottomRightRadius: 20,
        borderBottomLeftRadius: 20,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                gap: 5,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "span",
                        color: "$contentPrimary",
                        typography: "$labelSmall",
                        $largerThanMD: {
                            typography: "$labelMedium"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Headline, {
                            experience: returnExperienceData.experienceType,
                            currentOfferPriceCents: returnExperienceData.currentOfferHeadlinePriceCents,
                            previousOfferPriceCents: returnExperienceData.previousOfferHeadlinePriceCents,
                            daysToExpire: returnExperienceData.offerExpiresInDays,
                            smallerThanMD: smallerThanSM
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "span",
                        color: "$contentSecondary",
                        typography: "$bodySmall",
                        children: returnExperienceData.address
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExperienceCTAButton, {
                experience: returnExperienceData.experienceType,
                sellerInputUUID: returnExperienceData.sellerInputUUID,
                customerUUID: returnExperienceData.customerUUID,
                addressToken: returnExperienceData.addressToken,
                smallerThanMD: false
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./src/components/helpers/LazyLoad.tsx
var LazyLoad = __webpack_require__(17976);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Marker.tsx
var Marker = __webpack_require__(77741);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/hero/HeroMarkers.tsx




var markerBaseStyles = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(Marker/* MarkerFadeIn */.Yt, "  @media (min-width:1201px){height:80px;width:195px;}");
var HeroMarkers = function(param) {
    var cashOfferMarkerImage = param.cashOfferMarkerImage, newOfferMarkerImage = param.newOfferMarkerImage, highestOfferMarkerImage = param.highestOfferMarkerImage;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LazyLoad/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Marker/* default */.ZP, {
                    imageSource: cashOfferMarkerImage,
                    preload: true,
                    lazy: false,
                    left: "57%",
                    top: "40%",
                    height: 59,
                    width: 144,
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(markerBaseStyles, "            @media (min-width:768px){left:60%;top:40%;}@media (min-width:1201px){left:50%;top:25%;}"),
                    animationDelay: "0.5s"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LazyLoad/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Marker/* default */.ZP, {
                    imageSource: newOfferMarkerImage,
                    preload: true,
                    lazy: false,
                    right: "55%",
                    top: "45%",
                    height: 59,
                    width: 144,
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(markerBaseStyles, "            @media (min-width:768px){right:52%;top:43%;}@media (min-width:1201px){right:57%;top:30%;}"),
                    animationDelay: "1.5s"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LazyLoad/* default */.Z, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Marker/* default */.ZP, {
                    imageSource: highestOfferMarkerImage,
                    preload: true,
                    lazy: false,
                    right: "35%",
                    top: "20%",
                    height: 59,
                    width: 144,
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(markerBaseStyles, "            @media (min-width:768px){right:40%;top:22%;}@media (min-width:1201px){right:36%;top:7%;}"),
                    animationDelay: "2.5s"
                })
            })
        ]
    });
};
/* harmony default export */ var hero_HeroMarkers = (HeroMarkers);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/HeroShared.tsx
var HeroShared = __webpack_require__(21076);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/HeroV2WithMarkers.tsx












var RenderHeroV2WithMarkers = function(entry, resolvedData) {
    var fields = entry.fields;
    var authentication = (0,auth_fe_esm/* useAuth */.aC)().authentication;
    var showReturnExperience = (0,ReturnExperienceContext/* useReturnExperienceContext */.$)().showReturnExperience;
    var addressInputCommonProps = {
        hideLabel: true,
        inputLocation: "hero-cta",
        analyticsPrefix: "cosmos-landing-page-hero-v2-with-markers".concat((fields === null || fields === void 0 ? void 0 : fields.analyticsId) ? "-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId) : ""),
        trackingTaxonomy: "new_homepage"
    };
    // Convert resolvedData to match HeroV2's expected format
    var heroV2ResolvedData = resolvedData ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, resolvedData), {
        stickyCTA: resolvedData.stickyCTA || undefined
    }) : undefined;
    var customization = {
        variant: "withMarkers",
        hideStickyCtaOverride: entry.sys.locale === "es" || (resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.stickyCTA) === "None" || authentication.state === "authenticated",
        renderDesktopInput: function() {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, addressInputCommonProps), {
                placeholder: fields.addressCtaPlaceholderText || "Enter your home address"
            }));
        },
        renderMobileInput: function() {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, addressInputCommonProps), {
                placeholder: fields.addressCtaPlaceholderTextSmall || "Enter an address"
            }));
        },
        additionalAddressContent: showReturnExperience && entry.sys.locale !== "es" && !((fields === null || fields === void 0 ? void 0 : fields.analyticsId) === "syw-address-entry-direct-mail") ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReturnExperienceHero, {}) : undefined,
        imageContainerStyles: {
            $largerThanMD: {
                width: "50%",
                justifyContent: "flex-end"
            }
        },
        desktopPressBoxBottom: "$15x",
        headline: (fields === null || fields === void 0 ? void 0 : fields.title) || "",
        analyticsName: "cosmos-landing-page-hero-v2-with-markers-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(hero_HeroMarkers, {
            cashOfferMarkerImage: fields.cashOfferMarkerImage,
            newOfferMarkerImage: fields.newOfferMarkerImage,
            highestOfferMarkerImage: fields.highestOfferMarkerImage
        })
    };
    return (0,HeroV2/* RenderHeroV2 */.b)(entry, heroV2ResolvedData, customization);
};
var heroV2WithMarkersLoader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input, root) {
        var preloadImages, loaderReturn;
        return (0,tslib_es6.__generator)(this, function(_state) {
            preloadImages = (0,HeroShared/* preloadHeroImages */.DB)({
                imageDesktopUrl: input.fields.imageDesktopUrl,
                imageMobileUrl: input.fields.imageMobileUrl
            });
            loaderReturn = {
                preloadImages: preloadImages,
                stickyCTA: (0,HeroShared/* getStickyCTAFromRoot */.Ul)(root) || null
            };
            return [
                2,
                loaderReturn
            ];
        });
    });
    return function heroV2WithMarkersLoader(input, root) {
        return _ref.apply(this, arguments);
    };
}();
var HeroV2WithMarkers = {
    render: RenderHeroV2WithMarkers,
    loader: heroV2WithMarkersLoader
};
/* harmony default export */ var landing_pages_v2_HeroV2WithMarkers = (HeroV2WithMarkers);


/***/ }),

/***/ 97661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ StickyCTAUtility; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Flex/Flex.mjs
var Flex = __webpack_require__(93298);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Text/Text.mjs
var Text = __webpack_require__(4796);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/StickyCTAUtility/animations.js

var ANIMATION_DURATION = 0.7;
var revealAnimationKeyFrames = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("0%{transform:translateX(-50%) translateY(-100%) scale(90%);opacity:0.9}100%{transform:translateX(-50%) translateY(0%) scale(100%);opacity:1}");
var REVEAL_ANIMATION = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)({
    animation: "".concat(revealAnimationKeyFrames, " ").concat(ANIMATION_DURATION, "s")
});
var hideAnimationKeyFrames = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("0%{transform:translateX(-50%) translateY(0%) scale(100%);opacity:1}100%{transform:translateX(-50%) translateY(-100%) scale(90%);opacity:0.9}");
var HIDE_ANIMATION = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)({
    animation: "".concat(hideAnimationKeyFrames, " ").concat(ANIMATION_DURATION, "s")
});

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/StickyCTAUtility/StickyCTAUtility.tsx






var StickyCTAUtility = function(param) {
    var isVisible = param.isVisible, analyticsId = param.analyticsId, _style = param.style, style = _style === void 0 ? {} : _style;
    var ref = (0,react.useState)(false), showStickyCTAUtility = ref[0], setShowStickyCTAUtility = ref[1];
    var ref1 = (0,react.useState)(null), animate = ref1[0], setAnimate = ref1[1];
    (0,react.useEffect)(function() {
        setAnimate(isVisible ? REVEAL_ANIMATION : HIDE_ANIMATION);
        if (isVisible) {
            setShowStickyCTAUtility(true);
        }
        setTimeout(function() {
            setAnimate(null);
            if (!isVisible) {
                setShowStickyCTAUtility(false);
            }
        }, ANIMATION_DURATION * 1000);
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Flex/* default */.Z, {
        display: showStickyCTAUtility ? "flex" : "none",
        position: "fixed",
        zIndex: 9999,
        left: "50%",
        top: "2%",
        transform: "translate(-50%)",
        width: [
            "300px",
            null,
            "360px"
        ],
        justifyContent: "space-between",
        alignItems: "center",
        background: "linear-gradient(90deg, #F2F1F0, 64%, #F2F1F0)",
        backdropFilter: "blur(20px)",
        css: animate,
        boxShadow: "z2",
        padding: "6px",
        style: (0,_object_spread/* default */.Z)({
            borderRadius: "20px"
        }, style),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* default */.Z, {
                size: "130",
                fontWeight: "medium",
                px: [
                    5,
                    null,
                    6
                ],
                children: "Still selling?"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                maxWidth: 140,
                $largerThanLG: {
                    maxWidth: 160
                },
                onPress: function() {
                    return window.location.assign("/address-entry");
                },
                "aria-label": "sticky CTA utility",
                analyticsName: "cosmos-landing-page-sticky-cta-".concat(analyticsId),
                variant: "primary",
                size: "xsmall",
                label: "Get cash offer",
                minHeight: "$16x",
                $largerThanMD: {
                    minHeight: 52
                }
            })
        ]
    });
};


/***/ }),

/***/ 77741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RV": function() { return /* binding */ MarkerPulse; },
/* harmony export */   "Yt": function() { return /* binding */ MarkerFadeIn; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8013);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93298);
/* harmony import */ var components_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29212);







function createFadeAnimation(opacityValue) {
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .keyframes */ .F4)("0%{opacity:1;transform:scale(0.9);}30%{transform:scale(0.95);}50%{transform:scale(1);}100%{opacity:", opacityValue, ";transform:scale(1);}");
}
var MarkerPulse = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
    opacity: 0,
    transform: "scale(1)",
    animation: "".concat(createFadeAnimation(0), " 5s infinite")
});
var MarkerFadeIn = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)({
    opacity: 0,
    transform: "scale(1)",
    animation: "".concat(createFadeAnimation(1), " 5s forwards")
});
var Marker = function(_param) {
    var imageSource = _param.imageSource, _preload = _param.preload, preload = _preload === void 0 ? false : _preload, _lazy = _param.lazy, lazy = _lazy === void 0 ? true : _lazy, _animationDelay = _param.animationDelay, animationDelay = _animationDelay === void 0 ? "0s" : _animationDelay, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "imageSource",
        "preload",
        "lazy",
        "animationDelay"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        position: "absolute"
    }, props), {
        style: {
            animationDelay: animationDelay
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(components_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_0__/* .Picture */ .t, {
                preload: preload,
                lazy: lazy,
                radii: {},
                sources: [
                    {
                        srcSet: imageSource,
                        media: "(min-width: 0px)",
                        key: imageSource
                    }
                ],
                objectFit: "cover"
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (Marker);


/***/ }),

/***/ 21076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ useStickyCTA; },
/* harmony export */   "DB": function() { return /* binding */ preloadHeroImages; },
/* harmony export */   "Ul": function() { return /* binding */ getStickyCTAFromRoot; },
/* harmony export */   "bx": function() { return /* binding */ useHeroContext; },
/* harmony export */   "yL": function() { return /* binding */ HeroProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36305);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70131);
/* harmony import */ var _shared_performance_pictures__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29212);
/* harmony import */ var _heroConstants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78986);








var HeroContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var HeroProvider = function(param) {
    var variant = param.variant, analyticsPrefix = param.analyticsPrefix, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(HeroContext.Provider, {
        value: {
            variant: variant,
            analyticsPrefix: analyticsPrefix
        },
        children: children
    });
};
var useHeroContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HeroContext);
    if (!context) {
        throw new Error("useHeroContext must be used within a HeroProvider");
    }
    return context;
};
var useStickyCTA = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasBeenInView = ref[0], setHasBeenInView = ref[1];
    var ref1 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__/* .useInView */ .YD)(), addressEntryRef = ref1.ref, addressEntryInView = ref1.inView;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (addressEntryInView) {
            setHasBeenInView(true);
        }
    }, [
        addressEntryInView
    ]);
    // Only show after user has scrolled past it at least once
    var showStickyCTAUtility = hasBeenInView && !addressEntryInView;
    return {
        addressEntryRef: addressEntryRef,
        showStickyCTAUtility: showStickyCTAUtility
    };
};
var preloadHeroImages = function(param) {
    var imageDesktopUrl = param.imageDesktopUrl, imageMobileUrl = param.imageMobileUrl;
    var preloadImages = [];
    if (imageDesktopUrl) {
        var _preloadImages;
        var sources = (0,_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_1__/* .generatePresetPictureSetProps */ .$c)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _heroConstants__WEBPACK_IMPORTED_MODULE_2__/* .HERO_IMAGE_DESKTOP_PROPS */ .t), {
            photoUrl: imageDesktopUrl
        })).sources;
        (_preloadImages = preloadImages).push.apply(_preloadImages, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sources));
    }
    if (imageMobileUrl) {
        var _preloadImages1;
        var sources1 = (0,_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_1__/* .generatePresetPictureSetProps */ .$c)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _heroConstants__WEBPACK_IMPORTED_MODULE_2__/* .HERO_IMAGE_MOBILE_PROPS */ .S), {
            photoUrl: imageMobileUrl
        })).sources;
        (_preloadImages1 = preloadImages).push.apply(_preloadImages1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sources1));
    }
    return preloadImages;
};
var getStickyCTAFromRoot = function(root) {
    var ref;
    return (root === null || root === void 0 ? void 0 : (ref = root.fields) === null || ref === void 0 ? void 0 : ref.stickyCta) || "";
};


/***/ }),

/***/ 44636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ PressBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6967);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76614);




var LOGO_HEIGHT = 20;
var PRESET = "square-256";
var createLogoUrl = function(baseUrl, dpr) {
    var params = new URLSearchParams({
        preset: PRESET,
        service: "cosmos",
        dpr: "".concat(dpr)
    });
    return "".concat(baseUrl, "?").concat(params.toString());
};
var FORBES_LOGO_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903565-83391.png";
var FORTUNE_LOGO_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903560-61291.png";
var NEW_YORK_TIMES_LOGO_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903555-88900.png";
var WALL_STREET_JOURNAL_LOGO_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903562-10942.png";
var PRESS_LOGOS = [
    NEW_YORK_TIMES_LOGO_URL,
    FORBES_LOGO_URL,
    WALL_STREET_JOURNAL_LOGO_URL,
    FORTUNE_LOGO_URL, 
];
var PressBox = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
        justifyContent: "center",
        width: "100%",
        $largerThanMD: {
            width: "auto"
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            flexWrap: "wrap",
            columnGap: "$6x",
            padding: "$10x",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            borderRadius: 0,
            $largerThanSM: {
                borderRadius: 20,
                width: "unset"
            },
            style: {
                backgroundColor: "rgba(242, 241, 240, 0.64)",
                backdropFilter: "blur(20px)"
            }
        }, props), {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, {
                alignItems: "center",
                justifyContent: "center",
                style: {
                    display: "grid",
                    gridTemplateColumns: "repeat(3, max-content)",
                    gap: "24px",
                    width: "100%",
                    justifyItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                        tag: "span",
                        typography: "$bodyMedium",
                        color: "$contentStateInactivePrimary",
                        $smallerThanMD: {
                            width: "100%",
                            textAlign: "center"
                        },
                        children: "Featured in:"
                    }),
                    PRESS_LOGOS.map(function(photoUrl) {
                        var srcSet = [
                            "".concat(createLogoUrl(photoUrl, 1), " 1x"),
                            "".concat(createLogoUrl(photoUrl, 2), " 2x"),
                            "".concat(createLogoUrl(photoUrl, 3), " 3x"), 
                        ].join(", ");
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
                            height: LOGO_HEIGHT,
                            width: "auto",
                            display: "flex",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("img", {
                                src: createLogoUrl(photoUrl, 1),
                                srcSet: srcSet,
                                alt: "",
                                style: {
                                    height: "100%",
                                    width: "auto",
                                    objectFit: "contain"
                                }
                            })
                        }, photoUrl);
                    })
                ]
            })
        }))
    });
};


/***/ }),

/***/ 78986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ HERO_IMAGE_MOBILE_PROPS; },
/* harmony export */   "t": function() { return /* binding */ HERO_IMAGE_DESKTOP_PROPS; }
/* harmony export */ });
// Bricks-next breakpoints: SM (375px), MD (768px), LG (1201px), XL (1400px)
var BREAKPOINTS = {
    SM: 375,
    MD: 768,
    LG: 1201,
    XL: 1400
};
var HERO_DESKTOP_IMAGE_SIZES = [
    {
        minWidth: BREAKPOINTS.LG,
        maxWidth: BREAKPOINTS.XL,
        preset: "square-512"
    },
    {
        minWidth: BREAKPOINTS.XL,
        maxWidth: null,
        preset: "square-1024"
    }, 
];
var HERO_MOBILE_IMAGE_SIZES = [
    {
        minWidth: BREAKPOINTS.SM,
        maxWidth: BREAKPOINTS.MD,
        preset: "square-256"
    },
    {
        minWidth: BREAKPOINTS.MD,
        maxWidth: BREAKPOINTS.LG,
        preset: "square-512"
    }, 
];
var HERO_IMAGE_DESKTOP_PROPS = {
    sizes: HERO_DESKTOP_IMAGE_SIZES,
    debugImageSizes: false,
    lazy: false,
    preload: true,
    fetchPriority: "high",
    radii: {
        borderTopStartRadius: "none",
        borderBottomStartRadius: "none",
        borderTopEndRadius: "none",
        borderBottomEndRadius: "none"
    }
};
var HERO_IMAGE_MOBILE_PROPS = {
    sizes: HERO_MOBILE_IMAGE_SIZES,
    debugImageSizes: false,
    lazy: false,
    preload: true,
    fetchPriority: "high",
    radii: {
        borderTopStartRadius: "none",
        borderBottomStartRadius: "none",
        borderTopEndRadius: "none",
        borderBottomEndRadius: "none"
    }
};


/***/ }),

/***/ 4618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97582);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52007);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(8013);
/* harmony import */ var _opendoor_cinderblocks_core_AddressInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11582);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74593);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var helpers_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71899);
/* harmony import */ var helpers_observability__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77997);
/* harmony import */ var helpers_queryParams__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43552);
/* harmony import */ var _components_landing_pages_v2_AddressConfirmationModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75569);
/* harmony import */ var _helpers_AddressValidationContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47211);















var ManualEntryButton = function(param) {
    var onMouseDown = param.onMouseDown, onPress = param.onPress;
    var t = (0,helpers_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useT */ .NT)().t;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .TextButton */ .A, {
        zIndex: 2,
        onMouseDown: onMouseDown,
        label: t("homepage.titles.address", "Enter address manually instead"),
        analyticsName: "cosmos-address-input-manual-entry",
        type: "button",
        onPress: onPress,
        width: "100%",
        variant: "primary",
        size: "medium",
        px: 20,
        paddingTop: 10,
        paddingBottom: 20
    });
};
var NewSellerFlowAddressInput = function(param) {
    var actionButton = param.actionButton, channel = param.channel, hideLabel = param.hideLabel, icon = param.icon, inputLocation = param.inputLocation, pageSetPath = param.pageSetPath, placeholder = param.placeholder, trackingKeywords = param.trackingKeywords, trackingTaxonomy = param.trackingTaxonomy;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var trackJourneyEvent = (0,helpers_observability__WEBPACK_IMPORTED_MODULE_5__/* .useObservability */ .C3)().trackJourneyEvent;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), searchTerm = ref[0], setSearchTerm = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isFocused = ref1[0], setIsFocused = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isConfirmationModalOpen = ref2[0], setIsConfirmationModalOpen = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), predictions = ref3[0], setPredictions = ref3[1];
    var ref4 = (0,_helpers_AddressValidationContext__WEBPACK_IMPORTED_MODULE_8__/* .useAddressValidationContext */ .oK)(), validatedAddress = ref4.validatedAddress, setValidatedAddress = ref4.setValidatedAddress, setAddressResults = ref4.setAddressResults, setFirstPrediction = ref4.setFirstPrediction, setPartnerReferralId = ref4.setPartnerReferralId, setPageSetPath = ref4.setPageSetPath, setTrackingKeywords = ref4.setTrackingKeywords, setChannel = ref4.setChannel;
    var partner_referral = (0,helpers_queryParams__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().partner_referral;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (partner_referral) {
            setPartnerReferralId(partner_referral);
        }
        if (pageSetPath) {
            setPageSetPath(pageSetPath);
        }
        if (trackingKeywords) {
            setTrackingKeywords(trackingKeywords);
        }
        if (channel) {
            setChannel(channel);
        }
    }, [
        partner_referral,
        pageSetPath,
        trackingKeywords,
        channel
    ]);
    var handleMouseDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        e.preventDefault();
    }, []);
    var handleManualEntryPress = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        router.push({
            pathname: "/manual-address-entry",
            query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, trackingKeywords != null && {
                trackingKeywords: trackingKeywords
            }, partner_referral != null && {
                partnerReferralId: partner_referral
            }, pageSetPath != null && {
                pageSetPath: pageSetPath
            }, channel != null && {
                channel: channel
            })
        });
    }, [
        router,
        trackingKeywords,
        partner_referral,
        pageSetPath,
        channel
    ]);
    var handleFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setIsFocused(true);
    }, []);
    var handleBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setIsFocused(false);
    }, []);
    var handlePredictionsChange = function(newPredictions) {
        setPredictions(newPredictions);
        if (newPredictions.length > 0) {
            setFirstPrediction(newPredictions[0]);
        }
    };
    var handleSearchTermChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(newSearchTerm) {
        setSearchTerm(newSearchTerm);
    }, []);
    var customAction = predictions.length < 5 && searchTerm !== "" && isFocused ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(ManualEntryButton, {
        onMouseDown: handleMouseDown,
        onPress: handleManualEntryPress
    }) : undefined;
    var handleAddressValidated = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(validationResult) {
            var validatedAddr, results, needsManualEntry, needsUnitSelection, selectedAddress;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                validatedAddr = validationResult.address, results = validationResult.results, needsManualEntry = validationResult.needsManualEntry, needsUnitSelection = validationResult.needsUnitSelection;
                selectedAddress = {
                    id: validatedAddr.id,
                    street1: validatedAddr.street1,
                    city: validatedAddr.city,
                    state: validatedAddr.state,
                    postal_code: validatedAddr.postal_code,
                    unit: validatedAddr.unit,
                    latitude: validatedAddr.latitude,
                    longitude: validatedAddr.longitude,
                    result: results,
                    source: validatedAddr.source
                };
                setAddressResults(results);
                setValidatedAddress(selectedAddress);
                // Redirect to manual entry if needed
                if (needsManualEntry) {
                    router.push({
                        pathname: "/manual-address-entry",
                        query: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                            address: JSON.stringify(selectedAddress),
                            result: results
                        }, partner_referral != null && {
                            partnerReferralId: partner_referral
                        }, pageSetPath != null && {
                            pageSetPath: pageSetPath
                        }, trackingKeywords != null && {
                            trackingKeywords: trackingKeywords
                        }, channel != null && {
                            channel: channel
                        })
                    });
                    return [
                        2
                    ];
                }
                // Show confirmation modal if unit selection is needed
                if (needsUnitSelection) {
                    setIsConfirmationModalOpen(true);
                    return [
                        2
                    ];
                }
                setIsConfirmationModalOpen(true);
                return [
                    2
                ];
            });
        });
        return function handleAddressValidated(validationResult) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleError = function(error) {
        var _obj, ref;
        (ref = (_obj = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_2__/* .globalObservability.getSentryClient */ .w.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, error);
    };
    var handleAddressSelect = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function(address) {
            var ref;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                try {
                    ;
                    // Track analytics - flush immediately since navigation follows shortly
                    trackJourneyEvent("sell", "addressEntryV2", {
                        street1: address.street1,
                        city: address.city,
                        state: address.state,
                        postalCode: address.postal_code,
                        unit: address.unit,
                        latitude: address.latitude,
                        longitude: address.longitude,
                        sourcePage: router.asPath,
                        campaign: (ref = router.query) === null || ref === void 0 ? void 0 : ref.utm_campaign
                    }, {
                        flush: true
                    });
                } catch (e) {
                    handleError(e);
                }
                return [
                    2
                ];
            });
        });
        return function handleAddressSelect(address) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        flex: 1,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                className: "od-address-input",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    position: "relative",
                    zIndex: 2,
                    className: "cta-input-form",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_opendoor_cinderblocks_core_AddressInput__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        id: "home-address-input",
                        label: "Enter your home address",
                        hideLabel: hideLabel,
                        placeholder: placeholder,
                        disabled: false,
                        onAddressSelect: handleAddressSelect,
                        onAddressValidated: handleAddressValidated,
                        validateAddress: true,
                        onError: handleError,
                        onPredictionsChange: handlePredictionsChange,
                        onSearchTermChange: handleSearchTermChange,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        customAction: customAction,
                        listBoxId: "cb1-listbox",
                        listBoxAriaLabel: "addresses",
                        actionButton: actionButton,
                        icon: icon,
                        size: "large"
                    })
                })
            }),
            isConfirmationModalOpen && validatedAddress && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_components_landing_pages_v2_AddressConfirmationModal__WEBPACK_IMPORTED_MODULE_7__/* .AddressConfirmationModal */ .Xo, {
                setIsOpen: setIsConfirmationModalOpen,
                isOpen: isConfirmationModalOpen,
                partnerReferralId: partner_referral,
                initialAddress: validatedAddress,
                pageSetPath: pageSetPath,
                trackingKeywords: trackingKeywords,
                channel: channel,
                inputLocation: inputLocation,
                trackingTaxonomy: trackingTaxonomy
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NewSellerFlowAddressInput);


/***/ }),

/***/ 14314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RenderTrustpilotWidget": function() { return /* binding */ RenderTrustpilotWidget; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22470);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46523);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76614);
/* harmony import */ var components_landing_pages_v2_shared_Container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93524);






var TPLink = function(param) {
    var _href = param.href, href = _href === void 0 ? "https://www.trustpilot.com/review/opendoor.com" : _href;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r, {
        href: href,
        target: "_blank",
        rel: "noopener",
        analyticsName: "cosmos-landing-page-v2-trustpilot-link",
        children: "Trustpilot"
    });
};
var TPWidget = function(param) {
    var desktopContainerRef = param.desktopContainerRef, mobileContainerRef = param.mobileContainerRef, trustpilotCommonData = param.trustpilotCommonData, _hideFallback = param.hideFallback, hideFallback = _hideFallback === void 0 ? false : _hideFallback;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                ref: desktopContainerRef,
                className: "trustpilot-widget"
            }, trustpilotCommonData), {
                "data-token": trustpilotCommonData["data-token-desktop"],
                $smallerThanMD: {
                    display: "none"
                },
                children: hideFallback ? null : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(TPLink, {})
            })),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                ref: mobileContainerRef,
                className: "trustpilot-widget"
            }, trustpilotCommonData), {
                "data-token": trustpilotCommonData["data-token-mobile"],
                display: "none",
                $smallerThanMD: {
                    display: "block"
                },
                children: hideFallback ? null : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(TPLink, {})
            }))
        ]
    });
};
var TPRawClientWrapper = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isClient = ref[0], setIsClient = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setIsClient(true);
    }, []);
    return isClient ? children : null;
};
var RenderTrustpilotWidget = function(params) {
    var title = params.fields.title;
    var desktopContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var mobileContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var trustpilotCommonData = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            "data-locale": "en-US",
            "data-template-id": "53aa8912dec7e10d38f59f36",
            "data-businessunit-id": "5972843f0000ff0005a7274a",
            "data-style-height": "140px",
            "data-style-width": "100%",
            "data-stars": "4,5",
            "data-review-languages": "en",
            "data-token-desktop": "f5ac60d1-d0ba-4154-a67a-3b5d7d6f2e28",
            "data-token-mobile": "9361d9bc-b89c-41fd-ad2e-8daafedba526"
        }, params.tpCommonDataOverride);
    }, [
        params.tpCommonDataOverride
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (false) {}
        var tryLoad = function() {
            var ref;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var w = window;
            var didAttempt = false;
            if (w === null || w === void 0 ? void 0 : (ref = w.Trustpilot) === null || ref === void 0 ? void 0 : ref.loadFromElement) {
                if (desktopContainerRef.current) {
                    w.Trustpilot.loadFromElement(desktopContainerRef.current);
                    didAttempt = true;
                }
                if (mobileContainerRef.current) {
                    w.Trustpilot.loadFromElement(mobileContainerRef.current);
                    didAttempt = true;
                }
            }
            return didAttempt;
        };
        if (tryLoad()) return;
        var intervalId = window.setInterval(function() {
            if (tryLoad()) {
                window.clearInterval(intervalId);
            }
        }, 500);
        return function() {
            window.clearInterval(intervalId);
        };
    }, []);
    if (params.rawWidget) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(TPRawClientWrapper, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(TPWidget, {
                desktopContainerRef: desktopContainerRef,
                mobileContainerRef: mobileContainerRef,
                trustpilotCommonData: trustpilotCommonData,
                hideFallback: params === null || params === void 0 ? void 0 : params.hideFallback
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(components_landing_pages_v2_shared_Container__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            backgroundColor: "$backgroundSecondary",
            children: [
                title && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                    py: "$16x",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                        tag: "span",
                        display: "block",
                        typography: "$displaySmall",
                        $smallerThanMD: {
                            typography: "$headerSmall"
                        },
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                    pb: "$16x",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(TPWidget, {
                        desktopContainerRef: desktopContainerRef,
                        mobileContainerRef: mobileContainerRef,
                        trustpilotCommonData: trustpilotCommonData,
                        hideFallback: params === null || params === void 0 ? void 0 : params.hideFallback
                    })
                })
            ]
        })
    });
};
var TrustpilotWidget = {
    render: RenderTrustpilotWidget
};
/* harmony default export */ __webpack_exports__["default"] = (TrustpilotWidget);


/***/ }),

/***/ 29212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$c": function() { return /* binding */ generatePresetPictureSetProps; },
/* harmony export */   "eY": function() { return /* binding */ generatePresetPictureSet; },
/* harmony export */   "t": function() { return /* binding */ Picture; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61442);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);






var Picture = function(param) {
    var preload = param.preload, lazy = param.lazy, radii = param.radii, sources = param.sources, _objectFit = param.objectFit, objectFit = _objectFit === void 0 ? "cover" : _objectFit, customStyles = param.customStyles, fetchPriority = param.fetchPriority;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .Fragment */ .HY, {
        children: [
            preload && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
                children: sources.map(function(param) {
                    var srcSet = param.srcSet, media = param.media, key = param.key;
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("link", {
                        rel: "preload",
                        as: "image",
                        href: "",
                        // @ts-expect-error: react incorrectly capitalizes this if you use
                        // the "typescript" suggestion of `imgSrcSet`
                        imagesrcset: srcSet,
                        media: media,
                        fetchpriority: "high"
                    }, "".concat(key, "-preload"));
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("picture", {
                style: {
                    width: "100%"
                },
                children: [
                    sources.map(function(param) {
                        var srcSet = param.srcSet, media = param.media, key = param.key;
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("source", {
                            srcSet: srcSet,
                            media: media
                        }, "".concat(key, "-source"));
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        objectFit: objectFit,
                        width: "100%",
                        height: "100%",
                        alt: ""
                    }, radii), {
                        loading: lazy ? "lazy" : undefined,
                        css: customStyles,
                        // @ts-expect-error: fetchpriority is a valid attribute but missing from the type definition
                        fetchpriority: fetchPriority
                    }))
                ]
            })
        ]
    });
};
var generatePresetPictureSetProps = function(_param) {
    var photoUrl = _param.photoUrl, sizes = _param.sizes, radii = _param.radii, lazy = _param.lazy, _dpr = _param.dpr, dpr = _dpr === void 0 ? [
        1,
        2,
        3
    ] : _dpr, _preload = _param.preload, preload = _preload === void 0 ? false : _preload, objectFit = _param.objectFit, fetchPriority = _param.fetchPriority, quality = _param.quality, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "photoUrl",
        "sizes",
        "radii",
        "lazy",
        "dpr",
        "preload",
        "objectFit",
        "fetchPriority",
        "quality"
    ]);
    // sort in reverse because <source> matches in order, required to use
    // the min-width selectors
    var sortedSizes = sizes.sort(function(a, b) {
        return a.minWidth <= b.minWidth ? -1 : 1;
    });
    var sources = sortedSizes.map(function(param) {
        var minWidth = param.minWidth, maxWidth = param.maxWidth, preset = param.preset, presetScale = param.presetScale;
        var paramsRecord = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            preset: preset
        }, presetScale ? {
            presetScale: presetScale
        } : {}), {
            service: "cosmos",
            auto: "format,compress"
        }), quality !== undefined ? {
            q: "".concat(quality)
        } : {});
        var srcSet = dpr && (dpr === null || dpr === void 0 ? void 0 : dpr.length) > 0 ? dpr.map(function(d) {
            var finalParams = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, paramsRecord), {
                dpr: "".concat(d)
            });
            return "".concat(photoUrl, "?").concat(new URLSearchParams(finalParams).toString(), " ").concat(d, "x");
        }).join(", ") : "".concat(photoUrl, "?").concat(new URLSearchParams(paramsRecord).toString());
        var media = maxWidth === null ? "(min-width: ".concat(minWidth, "px)") : "(min-width: ".concat(minWidth, "px) and (max-width: ").concat(maxWidth - 1, "px)");
        return {
            srcSet: srcSet,
            media: media,
            key: "".concat(photoUrl, "-").concat(minWidth)
        };
    });
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        photoUrl: photoUrl,
        preload: preload,
        lazy: lazy,
        radii: radii,
        sources: sources,
        objectFit: objectFit,
        fetchPriority: fetchPriority
    }, props);
};
var generatePresetPictureSet = function(props) {
    var ref = generatePresetPictureSetProps(props), photoUrl = ref.photoUrl, preload = ref.preload, lazy = ref.lazy, radii = ref.radii, sources = ref.sources, objectFit = ref.objectFit, fetchPriority = ref.fetchPriority;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(Picture, {
        preload: preload,
        lazy: lazy,
        radii: radii,
        sources: sources,
        objectFit: objectFit,
        fetchPriority: fetchPriority
    }, photoUrl);
};


/***/ }),

/***/ 78223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useReturnExperienceContext; },
/* harmony export */   "Q": function() { return /* binding */ ReturnExperienceContextProvider; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _returnExperience__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82993);



var ReturnExperienceContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    returnExperienceData: null,
    showReturnExperience: false
});
var ReturnExperienceContextProvider = function(param) {
    var children = param.children, showReturnExperience = param.showReturnExperience;
    var returnExperienceData = (0,_returnExperience__WEBPACK_IMPORTED_MODULE_1__/* .useReturnExperience */ .lM)().returnExperienceData;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(ReturnExperienceContext.Provider, {
        value: {
            returnExperienceData: returnExperienceData,
            showReturnExperience: showReturnExperience
        },
        children: children
    });
};
var useReturnExperienceContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ReturnExperienceContext);
};


/***/ }),

/***/ 65446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O_": function() { return /* binding */ getMarketDisplayNameForHeroV2; },
/* harmony export */   "UE": function() { return /* binding */ US_STATE_CODES_OPTIONS; }
/* harmony export */ });
/* unused harmony exports getMarketDisplayNameWithState, getActiveSellDirectMarketOptions */
var US_STATE_CODES = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY", 
];
var US_STATE_CODES_OPTIONS = US_STATE_CODES.map(function(c) {
    return {
        value: c,
        label: c
    };
});
var MARKET_TO_STATE_ABBREV = {
    Asheville: "NC",
    Atlanta: "GA",
    Austin: "TX",
    Bakersfield: "CA",
    Birmingham: "AL",
    Boise: "ID",
    Charlotte: "NC",
    Chattanooga: "TN",
    Cincinnati: "OH",
    Clarksville: "TN",
    Cleveland: "OH",
    "Colorado Springs": "CO",
    Columbia: "SC",
    Columbus: "OH",
    "Corpus Christi": "TX",
    Dallas: "TX",
    Denver: "CO",
    "Fort Collins": "CO",
    Greensboro: "NC",
    Greenville: "SC",
    Houston: "TX",
    Huntsville: "AL",
    Indianapolis: "IN",
    Jacksonville: "FL",
    "Johnson City": "TN",
    "Kansas City": "KS",
    Killeen: "TX",
    Knoxville: "TN",
    "Las Vegas": "NV",
    "Los Angeles": "CA",
    Louisville: "KY",
    Memphis: "TN",
    Miami: "FL",
    Minneapolis: "MN",
    Nashville: "TN",
    "New York New Jersey": "NY",
    "Northern Colorado": "CO",
    "Oklahoma City": "OK",
    Orlando: "FL",
    Phoenix: "AZ",
    Portland: "OR",
    Prescott: "AZ",
    Raleigh: "NC",
    Reno: "NV",
    Riverside: "CA",
    Sacramento: "CA",
    "Salt Lake City": "UT",
    "San Antonio": "TX",
    "San Diego": "CA",
    "Sf Bay Area": "CA",
    Springfield: "MO",
    "St Louis": "MO",
    Tampa: "FL",
    Tucson: "AZ",
    Tulsa: "OK",
    Unknown: "",
    "Washington Dc": "D.C.",
    Wichita: "KS"
};
var getMarketDisplayNameWithState = function(market) {
    var edgeCase = handleMarketDisplayNameWithStateEdgeCases(market || "");
    if (edgeCase) {
        return edgeCase;
    }
    var splits = market.split("_");
    var stateAbbrev = "";
    // check if last element is a state code, remove it temporarily
    if (splits.length > 1 && splits[splits.length - 1].length === 2 && US_STATE_CODES.indexOf(splits[splits.length - 1].toUpperCase()) >= 0) {
        stateAbbrev = splits[splits.length - 1];
        splits = splits.slice(0, splits.length - 1);
    }
    // Generate sentence casing and re-append the state code
    var lowerCaseSplits = splits.map(function(s) {
        return s.toLowerCase();
    });
    var sentenceCaseMarketName = lowerCaseSplits.map(function(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }).join(" ");
    // Any markets launched after Q1 2022 will be systematically constructed e.g. Phoenix, AZ
    // The above constant (MARKET_TO_STATE_ABBREV) is a helper for markets created prior to this system,
    // and does not need to be used/updated for any future markets.
    stateAbbrev = stateAbbrev === "" ? stateAbbrev = MARKET_TO_STATE_ABBREV[sentenceCaseMarketName] : stateAbbrev.toUpperCase();
    return sentenceCaseMarketName + ", " + stateAbbrev;
};
function handleMarketDisplayNameWithStateEdgeCases(market) {
    if (market === "clarksville_ky_tn") {
        return "Clarksville, TN";
    }
    if (market === "louisville_in_ky") {
        return "Louisville, KY";
    }
    if (market === "sf_bay_area") {
        return "San Francisco Bay Area, CA";
    }
    if (market === "new_york_new_jersey") {
        return "New York / New Jersey";
    }
    if (market === "washington_dc") {
        return "Washington, D.C.";
    }
    if (market === "southwest_fl") {
        return "Southwest Florida";
    }
    return undefined;
}
var getMarketDisplayNameForHeroV2 = function(market) {
    if (market === "" || market === undefined) {
        return null;
    }
    var edgeCase = handleMarketDisplayNameEdgeCasesForHeroV2(market || "");
    if (edgeCase) {
        return edgeCase;
    }
    var splits = market.split("_");
    // check if last element is a state code, remove it
    if (splits.length > 1 && splits[splits.length - 1].length === 2 && US_STATE_CODES.indexOf(splits[splits.length - 1].toUpperCase()) >= 0) {
        splits = splits.slice(0, splits.length - 1);
    }
    // Generate sentence casing
    var lowerCaseSplits = splits.map(function(s) {
        return s.toLowerCase();
    });
    var sentenceCaseMarketName = lowerCaseSplits.map(function(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }).join(" ");
    return sentenceCaseMarketName;
};
function handleMarketDisplayNameEdgeCasesForHeroV2(market) {
    if (market === "clarksville_ky_tn") {
        return "Clarksville";
    }
    if (market === "louisville_in_ky") {
        return "Louisville";
    }
    if (market === "sf_bay_area") {
        return "the Bay";
    }
    if (market === "new_york_new_jersey") {
        return "the Northeast";
    }
    if (market === "milwaukee_waukesha_wi") {
        return "Milwaukee";
    }
    if (market === "washington_dc") {
        return "DC";
    }
    if (market === "southwest_fl") {
        return "Florida";
    }
    return undefined;
}
var alphabetize = function(a, b) {
    // eslint-disable-next-line no-nested-ternary -- Grandfathered violation
    return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
};
var getActiveSellDirectMarketOptions = function(markets) {
    var activeSellDirectMarkets = markets.filter(function(market) {
        var ref;
        if ((ref = market.marketData) === null || ref === void 0 ? void 0 : ref.launchDate) {
            var ref1, ref2;
            // returns seconds since epoch
            var now = Date.now();
            // returns seconds since epoch
            var launchDate = Date.parse((ref1 = market.marketData) === null || ref1 === void 0 ? void 0 : ref1.launchDate);
            // Note: actual offset is +7 or +8 depending on daylight savings time
            // this doesn't have to be exact, so choosing +8
            var PST_OFFSET_MS = 8 * 60 * 60 * 1000;
            // only display the market is acive and the launch date has passed
            // add an offset, to standardize this check on PST
            return ((ref2 = market.marketData) === null || ref2 === void 0 ? void 0 : ref2.active) && launchDate + PST_OFFSET_MS <= now;
        }
    });
    var marketOptions = activeSellDirectMarkets.map(function(market) {
        var identifier = market.marketData.marketIdentifier;
        var option = {
            label: getMarketDisplayNameWithState(identifier),
            value: market.marketData.homesPath
        };
        return option;
    });
    return marketOptions.sort(alphabetize);
};


/***/ }),

/***/ 82993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ ExperienceType; },
/* harmony export */   "lM": function() { return /* binding */ useReturnExperience; }
/* harmony export */ });
/* unused harmony export getReturnExperienceData */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64211);





var fetchSellerReturnExperience = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var sellerInputUUID, response, returnExperienceData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sellerInputUUID = js_cookie__WEBPACK_IMPORTED_MODULE_1___default().get("sellerInputUUID") || localStorage.getItem("sellerInputUUID");
                    if (!sellerInputUUID) {
                        return [
                            2
                        ];
                    }
                    localStorage.setItem("sellerInputUUID", sellerInputUUID);
                    return [
                        4,
                        _components_api__WEBPACK_IMPORTED_MODULE_2__/* .fetchSellerReturnExperience */ .cv(sellerInputUUID)
                    ];
                case 1:
                    response = _state.sent();
                    if (!response || !response.data) {
                        return [
                            2
                        ];
                    }
                    returnExperienceData = getReturnExperienceData(response.data, sellerInputUUID);
                    if (returnExperienceData.experienceType === null) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        {
                            returnExperienceData: returnExperienceData
                        }
                    ];
            }
        });
    });
    return function fetchSellerReturnExperience() {
        return _ref.apply(this, arguments);
    };
}();
var buildAddress = function(street, unitType, unitNumber, city, state, postalCode) {
    var address = "";
    if (street && unitNumber) {
        address = "".concat(street, " ").concat(unitType, " ").concat(unitNumber, ",");
    } else if (street) {
        address = "".concat(street);
    }
    if (city) {
        address += ", ".concat(city, ",");
    }
    if (state) {
        address += " ".concat(state);
    }
    if (postalCode) {
        address += " ".concat(postalCode);
    }
    return address;
};
var ExperienceType;
(function(ExperienceType) {
    ExperienceType[ExperienceType["offer_expired"] = 0] = "offer_expired";
    ExperienceType[ExperienceType["incomplete_flow"] = 1] = "incomplete_flow";
    ExperienceType[ExperienceType["offer_expiring"] = 2] = "offer_expiring";
    ExperienceType[ExperienceType["offer_decreased"] = 3] = "offer_decreased";
    ExperienceType[ExperienceType["offer_increased"] = 4] = "offer_increased";
    ExperienceType[ExperienceType["active_offer"] = 5] = "active_offer";
    ExperienceType[ExperienceType["direct_mailer"] = 6] = "direct_mailer";
})(ExperienceType || (ExperienceType = {}));
var OFFER_EXPIRY_DAYS_CUTOFF = 4;
var getReturnExperienceData = function(data, sellerInputUUID) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    if (!((ref = data.sellDirect) === null || ref === void 0 ? void 0 : ref.getLead) && !((ref1 = data.reception) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.getSellerInput) === null || ref2 === void 0 ? void 0 : ref2.sellerInput.address)) {
        return {
            experienceType: null
        };
    }
    var answers = (ref3 = data.reception.getSellerInput) === null || ref3 === void 0 ? void 0 : ref3.sellerInput.answers;
    var productOfferings = (ref4 = data.reception.getSellerInput) === null || ref4 === void 0 ? void 0 : ref4.sellerInput.productOfferings;
    var sellDirectProductOffering = productOfferings === null || productOfferings === void 0 ? void 0 : productOfferings.find(function(po) {
        return po.product === "OPENDOOR_DIRECT";
    });
    var sellDirectDenied = sellDirectProductOffering === null || sellDirectProductOffering === void 0 ? void 0 : sellDirectProductOffering.deniedAt;
    // If the lead is denied for sell direct then there is no return experience for them.
    if (sellDirectDenied) {
        return {
            experienceType: null
        };
    }
    var sellerInputAddress = (ref5 = data.reception.getSellerInput) === null || ref5 === void 0 ? void 0 : ref5.sellerInput.address;
    var addressFull = buildAddress(sellerInputAddress.street, sellerInputAddress.unitType, sellerInputAddress.unitNumber, sellerInputAddress.city, sellerInputAddress.state, sellerInputAddress.postalCode);
    // Without an email the lead could not have qualified and thus we want to show the incomplete experience at this stage
    if (!answers.email) {
        var ref17, ref18;
        return {
            sellerInputUUID: sellerInputUUID,
            address: (ref17 = data.reception.getSellerInput) === null || ref17 === void 0 ? void 0 : ref17.sellerInput.address.street,
            addressFull: addressFull,
            experienceType: ExperienceType.incomplete_flow,
            sellerFlowLastCompletedSlug: (ref18 = data.reception.getSellerInput) === null || ref18 === void 0 ? void 0 : ref18.sellerInput.sellerFlowLastCompletedSlug
        };
    }
    // Check if the lead was qualified in web
    var hasSellDirectExperience = (ref6 = data.sellDirect.getLead) === null || ref6 === void 0 ? void 0 : ref6.lead.isQualified;
    if (!hasSellDirectExperience) {
        return {
            experienceType: null
        };
    }
    // user has a sell direct offer
    var lead = (ref7 = data.sellDirect.getLead) === null || ref7 === void 0 ? void 0 : ref7.lead;
    var address = (ref8 = lead.address) === null || ref8 === void 0 ? void 0 : ref8.street;
    var addressToken = (ref9 = lead.address) === null || ref9 === void 0 ? void 0 : ref9.uuid;
    var customerUUID = (ref10 = lead.customerV2) === null || ref10 === void 0 ? void 0 : ref10.uuid;
    var firstName = (ref11 = lead.customerV2) === null || ref11 === void 0 ? void 0 : ref11.firstName;
    var offerRequestSource = (ref12 = lead.latestOffer) === null || ref12 === void 0 ? void 0 : ref12.offerRequestSource;
    var currentOfferHeadlinePriceCents = (ref13 = lead.latestOffer) === null || ref13 === void 0 ? void 0 : ref13.headlinePriceCents;
    var previousOfferHeadlinePriceCents = (ref14 = lead.previousOffer) === null || ref14 === void 0 ? void 0 : ref14.headlinePriceCents;
    var offerState = (ref15 = lead.latestOffer) === null || ref15 === void 0 ? void 0 : ref15.state;
    var offerExpiresAt = (ref16 = lead.latestOffer) === null || ref16 === void 0 ? void 0 : ref16.preliminaryOfferExpirationDate;
    var isQualifiedLead = lead.isQualified;
    var offerExpiresInDays = undefined;
    if (offerExpiresAt) {
        var currentTime = new Date().getTime();
        var expirationTime = Date.parse(offerExpiresAt);
        // convert the milliseconds time difference into days and round up to nearest number of days
        offerExpiresInDays = Math.ceil((expirationTime - currentTime) / (1000 * 3600 * 24));
    }
    var experienceType = null;
    if (offerState == "EXPIRED" && isQualifiedLead) {
        // let's only set the experience type to be "offer_expired" when we know that this lead is eligible for offer refresh (qualified for opendoor direct)
        experienceType = ExperienceType.offer_expired;
    } else if (offerState == "SENT" && offerExpiresInDays && offerExpiresInDays > 0 && offerExpiresInDays <= OFFER_EXPIRY_DAYS_CUTOFF) {
        experienceType = ExperienceType.offer_expiring;
    } else if (offerState == "SENT" && currentOfferHeadlinePriceCents && previousOfferHeadlinePriceCents && currentOfferHeadlinePriceCents - previousOfferHeadlinePriceCents >= 1000) {
        experienceType = ExperienceType.offer_increased;
    } else if (offerState == "SENT" && currentOfferHeadlinePriceCents && previousOfferHeadlinePriceCents && currentOfferHeadlinePriceCents < previousOfferHeadlinePriceCents) {
        experienceType = ExperienceType.offer_decreased;
    } else if (offerState == "SENT") {
        experienceType = ExperienceType.active_offer;
    }
    return {
        sellerInputUUID: sellerInputUUID,
        address: address,
        addressFull: addressFull,
        addressToken: addressToken,
        customerUUID: customerUUID,
        firstName: firstName,
        offerRequestSource: offerRequestSource,
        currentOfferHeadlinePriceCents: currentOfferHeadlinePriceCents,
        previousOfferHeadlinePriceCents: previousOfferHeadlinePriceCents,
        offerExpiresInDays: offerExpiresInDays,
        experienceType: experienceType
    };
};
// Custom hook to handle fetching return experience logic
var useReturnExperience = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        experienceType: null
    }), returnExperienceData = ref[0], setReturnExperienceData = ref[1];
    var returnExperienceShown = returnExperienceData.experienceType !== null;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        function start() {
            return _start.apply(this, arguments);
        }
        function _start() {
            _start = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                var result;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchSellerReturnExperience()
                            ];
                        case 1:
                            result = _state.sent();
                            if (!result) {
                                return [
                                    2
                                ];
                            }
                            setReturnExperienceData(result.returnExperienceData);
                            return [
                                2
                            ];
                    }
                });
            });
            return _start.apply(this, arguments);
        }
        start();
    }, []);
    return {
        returnExperienceData: returnExperienceData,
        returnExperienceShown: returnExperienceShown
    };
};


/***/ })

}]);